/*
    AUTOGENERATED - DO NOT EDIT: this file is auto-generated by the local type agent.
    @Copyright 2015 ORCA Intel orca-intel.com All Rights Reserved.
*/

window.RQParam = { };

window.RQParam.AuthLoginParams
    = function() {
    var params = { };
    
    params.RQueryAPIKey  = "";
    params.EntityTypeID  = 0;
    params.EntityGroupID = 0;
    params.EntityID      = 0;
    params.RoleID        = 0;
    params.AccountID     = 0;
    params.AccountName   = "";
    params.Credentials   = "";
    
    return params;
};

window.RQParam.ExtensionsRetrieveProfilePictureParams
     = function() {
    var params = { };
    
    params.ProfilePictureURL = "";
    
    return params;
};


window.RQParam.PmsAcceptAvUpdateDaysViaGridParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.StartDate  = "Date";
    params.LangID     = 0;
    params.AvDay1     = 0;
    params.AvDay2     = 0;
    params.AvDay3     = 0;
    params.AvDay4     = 0;
    params.AvDay5     = 0;
    params.AvDay6     = 0;
    params.AvDay7     = 0;
    params.AvDay8     = 0;
    params.AvDay9     = 0;
    params.AvDay10    = 0;
    params.AvDay11    = 0;
    params.AvDay12    = 0;
    params.AvDay13    = 0;
    params.AvDay14    = 0;
    params.AvDay15    = 0;
    params.AvDay16    = 0;
    params.AvDay17    = 0;
    params.AvDay18    = 0;
    params.AvDay19    = 0;
    params.AvDay20    = 0;
    params.AvDay21    = 0;
    params.AvDay22    = 0;
    params.AvDay23    = 0;
    params.AvDay24    = 0;
    params.AvDay25    = 0;
    params.AvDay26    = 0;
    params.AvDay27    = 0;
    params.AvDay28    = 0;
    params.AvDay29    = 0;
    params.AvDay30    = 0;
    params.AvDay31    = 0;

    return params;
};

window.RQParam.PmsAcceptAvUpdateDaysViaManualEntryParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.RoomTypeID   = 0;
    params.StartDate    = "Date";
    params.EndDate      = "Date";
    params.Availability = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsAcceptRateUpdateDaysViaManualEntryParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.RoomTypeID   = 0;
    params.OfferTypeID  = 0;
    params.MaxPersons   = 0;
    params.StartDate    = "Date";
    params.EndDate      = "Date";
    params.WithPrice    = 0;
    params.Price        = 0;
    params.WithMLOS     = 0;
    params.MLOS         = 0;
    params.WithMaxStay  = 0;
    params.MaxStay      = 0;
    params.WithNoArr    = 0;
    params.NoArr        = 0;
    params.WithNoDep    = 0;
    params.NoDep        = 0;
    params.WithStopSell = 0;
    params.StopSell     = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsAcceptRateUpdateDaysViaManualEntryFullParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.RoomTypeID      = 0;
    params.OfferTypeID     = 0;
    params.MaxPersons      = 0;
    params.StartDate       = "Date";
    params.EndDate         = "Date";
    params.WithPrice       = 0;
    params.Price           = 0;
    params.WithMLOS        = 0;
    params.MLOS            = 0;
    params.WithMaxStay     = 0;
    params.MaxStay         = 0;
    params.WithAdvanceDays = 0;
    params.AdvanceDays     = 0;
    params.WithNoArr       = 0;
    params.NoArr           = 0;
    params.WithNoDep       = 0;
    params.NoDep           = 0;
    params.WithStopSell    = 0;
    params.StopSell        = 0;
    params.LangID          = 0;

    return params;
};

window.RQParam.PmsAcceptRateUpdateWeekDaysViaManualEntryParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.RoomTypeID   = 0;
    params.OfferTypeID  = 0;
    params.MaxPersons   = 0;
    params.StartDate    = "Date";
    params.EndDate      = "Date";
    params.WithPrice    = 0;
    params.Price        = 0;
    params.WithMLOS     = 0;
    params.MLOS         = 0;
    params.WithMaxStay  = 0;
    params.MaxStay      = 0;
    params.WithNoArr    = 0;
    params.NoArr        = 0;
    params.WithNoDep    = 0;
    params.NoDep        = 0;
    params.WithStopSell = 0;
    params.StopSell     = 0;
    params.mon          = 0;
    params.tue          = 0;
    params.wed          = 0;
    params.thu          = 0;
    params.fri          = 0;
    params.sat          = 0;
    params.sun          = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsAcceptRateUpdateWeekDaysViaManualEntryFullParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.RoomTypeID      = 0;
    params.OfferTypeID     = 0;
    params.MaxPersons      = 0;
    params.StartDate       = "Date";
    params.EndDate         = "Date";
    params.WithPrice       = 0;
    params.Price           = 0;
    params.WithMLOS        = 0;
    params.MLOS            = 0;
    params.WithMaxStay     = 0;
    params.MaxStay         = 0;
    params.WithAdvanceDays = 0;
    params.AdvanceDays     = 0;
    params.WithNoArr       = 0;
    params.NoArr           = 0;
    params.WithNoDep       = 0;
    params.NoDep           = 0;
    params.WithStopSell    = 0;
    params.StopSell        = 0;
    params.mon             = 0;
    params.tue             = 0;
    params.wed             = 0;
    params.thu             = 0;
    params.fri             = 0;
    params.sat             = 0;
    params.sun             = 0;
    params.LangID          = 0;

    return params;
};

window.RQParam.PmsAdaptLocalAllotmentParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.MaxPersons  = 0;
    params.OfferTypeID = 0;
    params.Allotment   = 0;
    params.StartDate   = "Date";
    params.EndDate     = "Date";
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsAdaptLocalStopSellParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.MaxPersons  = 0;
    params.OfferTypeID = 0;
    params.StopSell    = 0;
    params.StartDate   = "Date";
    params.EndDate     = "Date";
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsAlertModificationHavingLocalPMSEditParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.PmsAlterDailyPriceInfoParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.MaxPersons  = 0;
    params.OfferTypeID = 0;
    params.Price       = 0;
    params.Allotment   = 0;
    params.Override    = 0;
    params.StartDate   = "Date";
    params.EndDate     = "Date";
    params.MLOS        = 0;
    params.MaxStay     = 0;
    params.AdvanceDays = 0;
    params.NoArr       = 0;
    params.NoDep       = 0;
    params.StopSell    = 0;
    params.FreeSale    = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsAlterRoomReservationStatusParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.RequiredStatusID  = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsAlterRoomTypeStopSellParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.StopSell   = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsAppendToReservationNotesParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.Notes         = "";
    params.UserID        = 0;

    return params;
};

window.RQParam.PmsAssignGuestToReservationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.GuestID       = 0;
    params.ThirdParty    = 0;
    params.UserID        = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsAssignGuestToRoomByRoomReservationParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.GuestID           = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsAssignPartnerToChannelParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.PartnerID   = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsAssignReservationToOwningGuestParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.GuestID       = 0;
    params.ThirdParty    = 0;
    params.UserID        = 0;

    return params;
};

window.RQParam.PmsAssignRoomReservationToOwningGuestParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.GuestID           = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsAttachRoomReservationSegmentParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.RoomID            = 0;
    params.FirstDay          = "Date";
    params.LastDay           = "Date";
    params.AdaptRates        = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsAuthenticateAdminPasswordParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.Credentials = "";

    return params;
};

window.RQParam.PmsBackupDataBaseParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsBlockOutOfOrderRoomParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.RoomID  = 0;
    params.begin   = "Date";
    params.end     = "Date";
    params.UserID  = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsCancelReservationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.ThirdParty    = 0;
    params.IsEngineEdit  = 0;
    params.UserID        = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsCancelRoomReservationParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.ThirdParty        = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsCheckAvailabilityParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.RoomTypeID    = 0;
    params.arr           = "Date";
    params.dep           = "Date";
    params.AllowDetached = 0;

    return params;
};

window.RQParam.PmsCheckAvailabilityMoveParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.SourceRoomTypeID = 0;
    params.SourceArr        = "Date";
    params.SourceDep        = "Date";
    params.SourceNumRooms   = 0;
    params.TargetRoomTypeID = 0;
    params.TargetArr        = "Date";
    params.TargetDep        = "Date";
    params.TargetNumRooms   = 0;

    return params;
};

window.RQParam.PmsCheckAvailableRoomsParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.RoomReservationID     = 0;
    params.arr                   = "Date";
    params.dep                   = "Date";
    params.OfferTypeID           = 0;
    params.ExclusiveRatePeriodID = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsCheckInRoomReservationParams
    = function() {
    var params = { };

    params.HotelID                   = 0;
    params.RoomReservationID         = 0;
    params.Override                  = 0;
    params.NumPersonsStaying         = 0;
    params.NumPersonsHavingBreakfast = 0;
    params.UserID                    = 0;
    params.LangID                    = 0;

    return params;
};

window.RQParam.PmsCheckOfferTypeCacheDataStatusParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsCheckOutRoomReservationParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.Override          = 0;
    params.PenaltyNights     = 0;
    params.TillID            = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsCheckResConstraintsParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomTypeID       = 0;
    params.MaxPersons       = 0;
    params.NumRooms         = 0;
    params.OfferTypeID      = 0;
    params.arr              = "Date";
    params.start            = "Date";
    params.finish           = "Date";
    params.dep              = "Date";
    params.IsIntersectCheck = 0;

    return params;
};

window.RQParam.PmsCheckRoomAvailabilityParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.RoomID        = 0;
    params.arr           = "Date";
    params.dep           = "Date";
    params.AllowDetached = 0;

    return params;
};

window.RQParam.PmsCheckRoomTypeCacheDataStatusParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsConfirmOTAReservationRetrievalParams
    = function() {
    var params = { };

    params.HotelID                   = 0;
    params.ExternalRoomReservationID = "";
    params.OTANewModifiedCancelled   = 0;

    return params;
};

window.RQParam.PmsConfirmOTAReservationRetrievalWithTokenParams
    = function() {
    var params = { };

    params.HotelID                   = 0;
    params.ExternalRoomReservationID = "";
    params.OTANewModifiedCancelled   = 0;
    params.OTAPartnerConfToken       = "";

    return params;
};

window.RQParam.PmsConfirmReservationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.UserID        = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsCountPendingChannelActionsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;

    return params;
};

window.RQParam.PmsCreateAccountParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.Email    = "";
    params.Password = "";

    return params;
};

window.RQParam.PmsCreateOrChangeGuiMessageParams
    = function() {
    var params = { };

    params.GuiKey     = "";
    params.GuiMessage = "";

    return params;
};

window.RQParam.PmsCreateOrEditCPolicyByOfferTypeParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.OfferTypeID           = 0;
    params.IsNonRefundable       = 0;
    params.ThresholdDay          = 0;
    params.ThresholdHour         = 0;
    params.PenaltyTypeID         = 0;
    params.Percentage            = 0;
    params.IsNoShowNonRefundable = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsCreateOrGetFormElementIDParams
    = function() {
    var params = { };

    params.FormID          = 0;
    params.FormElementName = "";

    return params;
};

window.RQParam.PmsCreateOrGetFormIDParams
    = function() {
    var params = { };

    params.FormName = "";

    return params;
};

window.RQParam.PmsDeleteAddonsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.ReservationID     = 0;
    params.RoomReservationID = 0;
    params.UserID            = 0;

    return params;
};

window.RQParam.PmsDeleteExhibitionPeriodParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.ExhibtionPeriodID = 0;

    return params;
};

window.RQParam.PmsDeleteOfferTypeParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsDeletePartnerParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsDeleteRackRatePeriodParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RackRatePeriodID = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsDeleteReservationInCreationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.UserID        = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsDeleteRoomParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.RoomID  = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsDeleteRoomPeriodNoteParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomPeriodNoteID = 0;

    return params;
};

window.RQParam.PmsDeleteRoomReservationParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.RoomReservationID     = 0;
    params.IsEngineChannelDelete = 0;
    params.UserID                = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsDeleteRoomTypeParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsDeleteRoomTypeNameParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.RoomTypeNameID = 0;
    params.LangID         = 0;

    return params;
};

window.RQParam.PmsDeleteSMTPServerParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.SMTPServerID = 0;

    return params;
};

window.RQParam.PmsDeleteTemplateParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.TemplateID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsDeleteUserParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.DeleteUserID = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsDetachRoomReservationSegmentParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.FirstDay          = "Date";
    params.LastDay           = "Date";
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsDowngradeRoomResWithExpiredHoldUntilParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.UserID  = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsEditCustomerParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.Email      = "";
    params.FirstName  = "";
    params.LastName   = "";
    params.CountryID  = 0;
    params.Mobile     = "";
    params.CCTypeID   = 0;
    params.CCName     = "";
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsEditCustomerPasswordParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.Password   = "";

    return params;
};

window.RQParam.PmsEditExhibitionPeriodParams
    = function() {
    var params = { };

    params.HotelID              = 0;
    params.ExhibitionPeriodID   = 0;
    params.start                = "Date";
    params.end                  = "Date";
    params.ExhibitionPeriodName = "";
    params.ColorID              = 0;
    params.LangID               = 0;

    return params;
};

window.RQParam.PmsEditExternalReservationIDParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.ReservationID         = 0;
    params.ExternalReservationID = "";

    return params;
};

window.RQParam.PmsEditGuestParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.GuestID                 = 0;
    params.ThirdParty              = 0;
    params.ThirdPartyReservationID = 0;
    params.ThirdPartyPartnerID     = 0;
    params.GuestTitleID            = 0;
    params.Gender                  = 0;
    params.Minor                   = 0;
    params.FirstName               = "";
    params.LastName                = "";
    params.Company                 = "";
    params.CompanyVAT              = "";
    params.CountryID               = 0;
    params.Address                 = "";
    params.Location                = "";
    params.PostCode                = "";
    params.Telephone               = "";
    params.TelephoneAlt            = "";
    params.Mobile                  = "";
    params.Fax                     = "";
    params.EMail                   = "";
    params.BirthPlace              = "";
    params.DateOfBirth             = "Date";
    params.IdentificationTypeID    = 0;
    params.Identification          = "";
    params.NationalIDNo            = "";
    params.IDRegistrationCity      = "";
    params.IDRegistrationDistrict  = "";
    params.TaxIdentification       = "";
    params.MothersName             = "";
    params.FathersName             = "";
    params.Occupation              = "";
    params.Notes                   = "";
    params.CCTypeID                = 0;
    params.CCNumber                = "";
    params.CCName                  = "";
    params.CCExpiryYear            = 0;
    params.CCExpiryMonth           = 0;
    params.CCCVC                   = "";
    params.UserID                  = 0;

    return params;
};

window.RQParam.PmsEditHotelDetailsParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.HotelName   = "";
    params.Title       = "";
    params.PostCode    = "";
    params.Address     = "";
    params.Location    = "";
    params.CountryID   = 0;
    params.PhoneICode  = 0;
    params.PhoneNumber = "";
    params.FaxICode    = 0;
    params.FaxNumber   = "";
    params.EMail       = "";
    params.Web         = "";

    return params;
};

window.RQParam.PmsEditHotelFinancialDetailsParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.ChamberOfCommerceNumber = "";
    params.FiscalNumber            = "";
    params.BankIBAN1               = "";
    params.BankIBAN2               = "";
    params.BankSwift1              = "";
    params.BankSwift2              = "";
    params.BankLocation1           = "";
    params.BankLocation2           = "";
    params.BankCountryID1          = 0;
    params.BankCountryID2          = 0;
    params.FiscalPostCode          = "";
    params.FiscalAddress           = "";
    params.FiscalLocation          = "";
    params.FiscalCountryID         = 0;

    return params;
};

window.RQParam.PmsEditHotelPasswordParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.Password = "";
    params.LangID   = 0;

    return params;
};

window.RQParam.PmsEditMLViewTextParams
    = function() {
    var params = { };

    params.CollectionID = 0;
    params.FormID       = 0;
    params.MLTextID     = 0;
    params.LangID       = 0;
    params.Translation  = "";

    return params;
};

window.RQParam.PmsEditNumPersonsStayingParams
    = function() {
    var params = { };

    params.HotelID                   = 0;
    params.RoomReservationID         = 0;
    params.NumPersonsStaying         = 0;
    params.NumPersonsHavingBreakfast = 0;

    return params;
};

window.RQParam.PmsEditOfferTypeParams
    = function() {
    var params = { };

    params.HotelID                    = 0;
    params.OfferTypeID                = 0;
    params.RackRatePaymentSchemeID    = 0;
    params.Credentials                = "";
    params.ReleaseDays                = 0;
    params.CancelConsumesAvailability = 0;
    params.LangID                     = 0;

    return params;
};

window.RQParam.PmsEditOfferTypeAsDiscountParams
    = function() {
    var params = { };

    params.HotelID                    = 0;
    params.OfferTypeID                = 0;
    params.RackRatePaymentSchemeID    = 0;
    params.Credentials                = "";
    params.ReleaseDays                = 0;
    params.CancelConsumesAvailability = 0;
    params.DiscountTypeID             = 0;
    params.Surcharge                  = 0;
    params.SourceMLOS                 = 0;
    params.SourceMaxStay              = 0;
    params.SourceAdvanceDays          = 0;
    params.SourceNoArr                = 0;
    params.SourceNoDep                = 0;
    params.SourceMaxPersons           = 0;
    params.InitialiseAllotmentToZero  = 0;
    params.LangID                     = 0;

    return params;
};

window.RQParam.PmsEditOfferTypeNameParams
    = function() {
    var params = { };

    params.HotelID              = 0;
    params.OfferTypeID          = 0;
    params.OfferTypeName        = "";
    params.OfferTypeDescription = "";
    params.LangID               = 0;

    return params;
};

window.RQParam.PmsEditPartnerParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.PartnerID                = 0;
    params.Partner                  = "";
    params.CommissionPercentage     = 0;
    params.CommissionPerReservation = 0;
    params.CommissionVAT            = 0;
    params.LangID                   = 0;

    return params;
};

window.RQParam.PmsEditPriorityNotesParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.ReservationID     = 0;
    params.NotePriorityLevel = 0;
    params.PriorityNotes     = "";
    params.ThirdParty        = 0;
    params.UserID            = 0;

    return params;
};

window.RQParam.PmsEditRackRateParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.RateID         = 0;
    params.Allotment      = 0;
    params.MonPrice       = 0;
    params.MonMLOS        = 0;
    params.MonMaxStay     = 0;
    params.MonAdvanceDays = 0;
    params.MonNoArr       = 0;
    params.MonNoDep       = 0;
    params.TuePrice       = 0;
    params.TueMLOS        = 0;
    params.TueMaxStay     = 0;
    params.TueAdvanceDays = 0;
    params.TueNoArr       = 0;
    params.TueNoDep       = 0;
    params.WedPrice       = 0;
    params.WedMLOS        = 0;
    params.WedMaxStay     = 0;
    params.WedAdvanceDays = 0;
    params.WedNoArr       = 0;
    params.WedNoDep       = 0;
    params.ThuPrice       = 0;
    params.ThuMLOS        = 0;
    params.ThuMaxStay     = 0;
    params.ThuAdvanceDays = 0;
    params.ThuNoArr       = 0;
    params.ThuNoDep       = 0;
    params.FriPrice       = 0;
    params.FriMLOS        = 0;
    params.FriMaxStay     = 0;
    params.FriAdvanceDays = 0;
    params.FriNoArr       = 0;
    params.FriNoDep       = 0;
    params.SatPrice       = 0;
    params.SatMLOS        = 0;
    params.SatMaxStay     = 0;
    params.SatAdvanceDays = 0;
    params.SatNoArr       = 0;
    params.SatNoDep       = 0;
    params.SunPrice       = 0;
    params.SunMLOS        = 0;
    params.SunMaxStay     = 0;
    params.SunAdvanceDays = 0;
    params.SunNoArr       = 0;
    params.SunNoDep       = 0;
    params.LangID         = 0;

    return params;
};

window.RQParam.PmsEditRackRateFilterAllotmentParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.RateID    = 0;
    params.Allotment = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsEditRackRatePeriodParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RackRatePeriodID = 0;
    params.start            = "Date";
    params.end              = "Date";
    params.Override         = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsEditReservationDetailsParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.ReservationID         = 0;
    params.ExternalReservationID = "";
    params.LetterSent            = 0;
    params.Notes                 = "";
    params.PartnerNotes          = "";
    params.HousekeepingNotes     = "";
    params.KitchenNotes          = "";
    params.EngineGuestComments   = "";
    params.ThirdParty            = 0;
    params.UserID                = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsEditReservationPartnerParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.PartnerID     = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsEditRoomParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomID     = 0;
    params.RoomNumber = "";
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsEditRoomPeriodNoteParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomPeriodNoteID  = 0;
    params.NotePriorityLevel = 0;
    params.Notes             = "";

    return params;
};

window.RQParam.PmsEditRoomReservationParamsParams
    = function() {
    var params = { };

    params.HotelID                             = 0;
    params.RoomReservationID                   = 0;
    params.RoomID                              = 0;
    params.MaxPersons                          = 0;
    params.arr                                 = "Date";
    params.dep                                 = "Date";
    params.OfferTypeID                         = 0;
    params.ExclusiveRatePeriodID               = 0;
    params.KeepRate                            = 0;
    params.IsHoldUntil                         = 0;
    params.HoldUntil                           = "Date";
    params.OverridePrice                       = 0;
    params.OverrideWithTaxes                   = 0;
    params.NumPersonsStaying                   = 0;
    params.NumPersonsHavingBreakfast           = 0;
    params.OverridePaymentSchemeConsistency    = 0;
    params.AllowManualTotalProductSpreadChange = 0;
    params.UserID                              = 0;
    params.LangID                              = 0;

    return params;
};

window.RQParam.PmsEditRoomTypeParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomTypeID       = 0;
    params.PersonsNormal    = 0;
    params.MaxPersonsNormal = 0;
    params.MinPrice         = 0;
    params.MaxPrice         = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsEditRoomTypeNameParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.RoomTypeNameID = 0;
    params.RoomTypeName   = "";
    params.LangID         = 0;

    return params;
};

window.RQParam.PmsEditRoomTypeNameAndParamsParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomTypeID       = 0;
    params.PersonsNormal    = 0;
    params.MaxPersonsNormal = 0;
    params.RoomTypeName     = "";
    params.NumRooms         = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsEditSMTPServerParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.SMTPServerID   = 0;
    params.Description    = "";
    params.ServerName     = "";
    params.Port           = 0;
    params.EnableSSL      = 0;
    params.UseCredentials = 0;
    params.Username       = "";
    params.Password       = "";
    params.IsPrimary      = 0;

    return params;
};

window.RQParam.PmsEditTemplateParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.TemplateID = 0;
    params.LangID     = 0;
    params.Title      = "";
    params.Subject    = "";
    params.FileName   = "";

    return params;
};

window.RQParam.PmsEditThirdPartyRoomReservationParamsParams
    = function() {
    var params = { };

    params.HotelID                        = 0;
    params.ReservationID                  = 0;
    params.SpecificRoomReservationID      = 0;
    params.RoomTypeID                     = 0;
    params.MaxPersons                     = 0;
    params.arr                            = "Date";
    params.dep                            = "Date";
    params.OfferTypeID                    = 0;
    params.ExclusiveRatePeriodID          = 0;
    params.DayPrice1                      = 0;
    params.DayPrice2                      = 0;
    params.DayPrice3                      = 0;
    params.DayPrice4                      = 0;
    params.DayPrice5                      = 0;
    params.DayPrice6                      = 0;
    params.DayPrice7                      = 0;
    params.DayPrice8                      = 0;
    params.DayPrice9                      = 0;
    params.DayPrice10                     = 0;
    params.DayPrice11                     = 0;
    params.DayPrice12                     = 0;
    params.DayPrice13                     = 0;
    params.DayPrice14                     = 0;
    params.DayPrice15                     = 0;
    params.DayPrice16                     = 0;
    params.DayPrice17                     = 0;
    params.DayPrice18                     = 0;
    params.DayPrice19                     = 0;
    params.DayPrice20                     = 0;
    params.DayPrice21                     = 0;
    params.DayPrice22                     = 0;
    params.DayPrice23                     = 0;
    params.DayPrice24                     = 0;
    params.DayPrice25                     = 0;
    params.DayPrice26                     = 0;
    params.DayPrice27                     = 0;
    params.DayPrice28                     = 0;
    params.SuppliedPrice                  = 0;
    params.SuppliedWithoutAdditionalTaxes = 0;
    params.UserID                         = 0;
    params.LangID                         = 0;

    return params;
};

window.RQParam.PmsEditUserParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.EditUserID       = 0;
    params.UserName         = "";
    params.Credentials      = "";
    params.IsAdmin          = 0;
    params.CanCloseJournal  = 0;
    params.CanReopenJournal = 0;
    params.IsAuditor        = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsExistBrokenResParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsExistNewNotificationsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.SinceWhen = "Date";

    return params;
};

window.RQParam.PmsExistUnverifiedNotificationsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsFinaliseFormTextExtractionPassParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsGetActiveBookingDotComReservationsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetActiveMonitoredHotelsParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetActiveRemotePartnersParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetAgeBasedOccupancyParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.EndDate   = "Date";

    return params;
};

window.RQParam.PmsGetAllOfferTypeBucketDataParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.PartnerID   = 0;
    params.OfferTypeID = 0;
    params.StartDate   = "Date";
    params.EndDate     = "Date";

    return params;
};

window.RQParam.PmsGetAssignedPartnersByOfferTypeParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetAvailabilityPeriodParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";

    return params;
};

window.RQParam.PmsGetAvailableRoomEditTotalsParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.RoomReservationID     = 0;
    params.OfferTypeID           = 0;
    params.ExclusiveRatePeriodID = 0;
    params.arr                   = "Date";
    params.dep                   = "Date";
    params.KeepRate              = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsGetAvailableRoomTotalsParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.OfferTypeID           = 0;
    params.ExclusiveRatePeriodID = 0;
    params.arr                   = "Date";
    params.dep                   = "Date";
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsGetBookingDotComDeviceCookieParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.DeviceLocationID = 0;

    return params;
};

window.RQParam.PmsGetCancellationFeeParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;

    return params;
};

window.RQParam.PmsGetCCTypesParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsGetChannelBucketNavigationDataParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsGetCountriesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetCountryIDByCodeParams
    = function() {
    var params = { };

    params.InternetCode = "";

    return params;
};

window.RQParam.PmsGetCountryIDByEnNameParams
    = function() {
    var params = { };

    params.CountryName = "";

    return params;
};

window.RQParam.PmsGetCountryIDByISOCodeParams
    = function() {
    var params = { };

    params.ISOCode = "";

    return params;
};

window.RQParam.PmsGetCountryParamsFromPathParams
    = function() {
    var params = { };

    params.CountryPName = "";
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsGetCPolicyByOfferTypeIDParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetCTMAccountSettingsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetCurrentCacheWindowParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetCurrentShiftParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetCurrentShiftStartParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetCustomerParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};

window.RQParam.PmsGetCustomerBookingHotelsParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsGetCustomerBookingsParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsGetCustomerIDByEmailParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.Email   = "";

    return params;
};

window.RQParam.PmsGetCustomerOffersByArrDepParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.PartnerID        = 0;
    params.arr              = "Date";
    params.dep              = "Date";
    params.NumAdults        = 0;
    params.NumChildren      = 0;
    params.NumMatchesToMark = 0;
    params.CurrencyID       = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsGetCustomerOffersByArrDepBoundsCoordsFullWithDiscountParams
    = function() {
    var params = { };

    params.PartnerID           = 0;
    params.arr                 = "Date";
    params.dep                 = "Date";
    params.NumAdults           = 0;
    params.NumChildren         = 0;
    params.NumMatchesToMark    = 0;
    params.SearchAllStars      = 0;
    params.Show0Stars          = 0;
    params.Show1Stars          = 0;
    params.Show2Stars          = 0;
    params.Show3Stars          = 0;
    params.Show4Stars          = 0;
    params.Show5Stars          = 0;
    params.AccommodationTypeID = 0;
    params.CurrencyID          = 0;
    params.PriceFilter1        = 0;
    params.PriceFilter2        = 0;
    params.PriceFilter3        = 0;
    params.PriceFilter4        = 0;
    params.MaxPhotosPerHotel   = 0;
    params.SortBy              = 0;
    params.AllowDiscount       = 0;
    params.LeftLat             = 0;
    params.RightLat            = 0;
    params.TopLng              = 0;
    params.BottomLng           = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetCustomerOffersByArrDepCoordsFullWithDiscountParams
    = function() {
    var params = { };

    params.PartnerID           = 0;
    params.arr                 = "Date";
    params.dep                 = "Date";
    params.NumAdults           = 0;
    params.NumChildren         = 0;
    params.NumMatchesToMark    = 0;
    params.SearchAllStars      = 0;
    params.Show0Stars          = 0;
    params.Show1Stars          = 0;
    params.Show2Stars          = 0;
    params.Show3Stars          = 0;
    params.Show4Stars          = 0;
    params.Show5Stars          = 0;
    params.AccommodationTypeID = 0;
    params.CurrencyID          = 0;
    params.PriceFilter1        = 0;
    params.PriceFilter2        = 0;
    params.PriceFilter3        = 0;
    params.PriceFilter4        = 0;
    params.MaxPhotosPerHotel   = 0;
    params.SortBy              = 0;
    params.AllowDiscount       = 0;
    params.Lat                 = 0;
    params.Lng                 = 0;
    params.Scale               = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetCustomerOffersByArrDepWithDiscountInfoParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.PartnerID        = 0;
    params.arr              = "Date";
    params.dep              = "Date";
    params.NumAdults        = 0;
    params.NumChildren      = 0;
    params.NumMatchesToMark = 0;
    params.CurrencyID       = 0;
    params.AllowDiscount    = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsGetCustomerOffersByLocationArrDepFullWithDiscountParams
    = function() {
    var params = { };

    params.LocationGeoCodeID   = 0;
    params.PartnerID           = 0;
    params.arr                 = "Date";
    params.dep                 = "Date";
    params.NumAdults           = 0;
    params.NumChildren         = 0;
    params.NumMatchesToMark    = 0;
    params.SearchAllStars      = 0;
    params.Show0Stars          = 0;
    params.Show1Stars          = 0;
    params.Show2Stars          = 0;
    params.Show3Stars          = 0;
    params.Show4Stars          = 0;
    params.Show5Stars          = 0;
    params.AccommodationTypeID = 0;
    params.CurrencyID          = 0;
    params.MaxDistance         = 0;
    params.PriceFilter1        = 0;
    params.PriceFilter2        = 0;
    params.PriceFilter3        = 0;
    params.PriceFilter4        = 0;
    params.MaxPhotosPerHotel   = 0;
    params.SortBy              = 0;
    params.AllowDiscount       = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscountParams
    = function() {
    var params = { };

    params.searchloc_id        = 0;
    params.PartnerID           = 0;
    params.arr                 = "Date";
    params.dep                 = "Date";
    params.NumAdults           = 0;
    params.NumChildren         = 0;
    params.NumMatchesToMark    = 0;
    params.SearchAllStars      = 0;
    params.Show0Stars          = 0;
    params.Show1Stars          = 0;
    params.Show2Stars          = 0;
    params.Show3Stars          = 0;
    params.Show4Stars          = 0;
    params.Show5Stars          = 0;
    params.AccommodationTypeID = 0;
    params.CurrencyID          = 0;
    params.PriceFilter1        = 0;
    params.PriceFilter2        = 0;
    params.PriceFilter3        = 0;
    params.PriceFilter4        = 0;
    params.MaxPhotosPerHotel   = 0;
    params.SortBy              = 0;
    params.AllowDiscount       = 0;
    params.Lat                 = 0;
    params.Lng                 = 0;
    params.Scale               = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetCustomerOffersBySearchLocationArrDepFullWithDiscountParams
    = function() {
    var params = { };

    params.searchloc_id        = 0;
    params.PartnerID           = 0;
    params.arr                 = "Date";
    params.dep                 = "Date";
    params.NumAdults           = 0;
    params.NumChildren         = 0;
    params.NumMatchesToMark    = 0;
    params.SearchAllStars      = 0;
    params.Show0Stars          = 0;
    params.Show1Stars          = 0;
    params.Show2Stars          = 0;
    params.Show3Stars          = 0;
    params.Show4Stars          = 0;
    params.Show5Stars          = 0;
    params.AccommodationTypeID = 0;
    params.CurrencyID          = 0;
    params.MaxDistance         = 0;
    params.PriceFilter1        = 0;
    params.PriceFilter2        = 0;
    params.PriceFilter3        = 0;
    params.PriceFilter4        = 0;
    params.MaxPhotosPerHotel   = 0;
    params.SortBy              = 0;
    params.AllowDiscount       = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHintParams
    = function() {
    var params = { };

    params.searchloc_id        = 0;
    params.PartnerID           = 0;
    params.arr                 = "Date";
    params.dep                 = "Date";
    params.NumAdults           = 0;
    params.NumChildren         = 0;
    params.NumMatchesToMark    = 0;
    params.SearchAllStars      = 0;
    params.Show0Stars          = 0;
    params.Show1Stars          = 0;
    params.Show2Stars          = 0;
    params.Show3Stars          = 0;
    params.Show4Stars          = 0;
    params.Show5Stars          = 0;
    params.AccommodationTypeID = 0;
    params.CurrencyID          = 0;
    params.PriceFilter1        = 0;
    params.PriceFilter2        = 0;
    params.PriceFilter3        = 0;
    params.PriceFilter4        = 0;
    params.MaxPhotosPerHotel   = 0;
    params.SortBy              = 0;
    params.AllowDiscount       = 0;
    params.PageHint            = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetDaysWithFineTunedRateDataParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";

    return params;
};

window.RQParam.PmsGetEarlyBirdOfferTypeParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetEasyNonRefOfferTypeParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetExclusiveRateChannelDataParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.RoomTypeID            = 0;
    params.MaxPersons            = 0;
    params.OfferTypeID           = 0;
    params.ExclusiveRatePeriodID = 0;
    params.arr                   = "Date";
    params.end                   = "Date";

    return params;
};

window.RQParam.PmsGetExclusiveRateDiscountFiltersParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.ExclusiveRatePeriodID = 0;
    params.OfferTypeID           = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsGetExclusiveRatePeriodsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetExhibitionDayWindowParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.NumDays   = 0;

    return params;
};

window.RQParam.PmsGetExhibitionPeriodsParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.ShowPastPeriods = 0;

    return params;
};

window.RQParam.PmsGetFirstBusinessDayParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetGuestParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.GuestID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetGuestByReservationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.GuestID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetGuestIdentificationTypesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetGuestTitlesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetHotelParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetHotelBreakfastDataParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.ReportDay        = "Date";
    params.CheckedInResOnly = 0;

    return params;
};

window.RQParam.PmsGetHotelBreakfastDefaultParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetHotelModulesParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetHotelOccupancyAndBreakfastTotalsParams
    = function() {
    var params = { };

    params.HotelID                   = 0;
    params.ReportDay                 = "Date";
    params.CheckedInOnlyForBreakfast = 0;
    params.WithTodaysCheckouts       = 0;
    params.WithTodaysCheckIns        = 0;
    params.WithAllOngoingStays       = 0;

    return params;
};

window.RQParam.PmsGetHotelOccupancyDataParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.ReportDay           = "Date";
    params.WithTodaysCheckouts = 0;
    params.WithTodaysCheckIns  = 0;
    params.WithAllOngoingStays = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetHotelsAndActiveRemotePartnersParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsGetHotelsNeedingConfigCacheSyncParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsGetIntersectingRoomRatesParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.arr         = "Date";
    params.dep         = "Date";
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsGetJobsParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.EnabledOnly = 0;

    return params;
};

window.RQParam.PmsGetLanguagesParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsGetLocalPartnerFromGatewayPartnerParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.PartnerID        = 0;
    params.GatewayPartnerID = "";

    return params;
};

window.RQParam.PmsGetLocationAndHotelParamsFromPathParams
    = function() {
    var params = { };

    params.CountryPName  = "";
    params.LocationPName = "";
    params.HotelPName    = "";
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetLocationAndHotelParamsFromPathMLParams
    = function() {
    var params = { };

    params.CountryPName  = "";
    params.LocationPName = "";
    params.HotelPName    = "";
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetLocationParamsFromPathParams
    = function() {
    var params = { };

    params.CountryPName  = "";
    params.LocationPName = "";
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetLocationParamsFromPathMLParams
    = function() {
    var params = { };

    params.CountryPName  = "";
    params.LocationPName = "";
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetMaxPersonsRateNamesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetMaxPersonsRateNamesByRoomTypeParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsGetMessageByErrorCodeParams
    = function() {
    var params = { };

    params.ErrorCode = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsGetMixedRoomRateOfferDayInfoAllParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.MaxPersons  = 0;
    params.OfferTypeID = 0;
    params.ResDay      = "Date";

    return params;
};

window.RQParam.PmsGetMixedRoomRateOfferInfoParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.OfferTypeID = 0;
    params.start       = "Date";

    return params;
};

window.RQParam.PmsGetMixedRoomRateOfferInfoAllParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.MaxPersons  = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetMixedRoomRateOfferTotalParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomTypeID       = 0;
    params.MaxPersons       = 0;
    params.NumRooms         = 0;
    params.OfferTypeID      = 0;
    params.arr              = "Date";
    params.start            = "Date";
    params.finish           = "Date";
    params.dep              = "Date";
    params.IsIntersectCheck = 0;

    return params;
};

window.RQParam.PmsGetMixedRoomRateOfferTotalWithDiscountParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomTypeID       = 0;
    params.MaxPersons       = 0;
    params.NumRooms         = 0;
    params.OfferTypeID      = 0;
    params.arr              = "Date";
    params.start            = "Date";
    params.finish           = "Date";
    params.dep              = "Date";
    params.IsIntersectCheck = 0;
    params.AllowDiscount    = 0;

    return params;
};

window.RQParam.PmsGetMLViewsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsGetMLViewTextsParams
    = function() {
    var params = { };

    params.CollectionID = 0;
    params.FormID       = 0;
    params.LangID       = 0;
    params.MissingOnly  = 0;
    params.WithFallback = 0;

    return params;
};

window.RQParam.PmsGetNotificationEventParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.NotificationEventID = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetNotificationEventsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetOccupancyDataParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsGetOccupancyDataWindowParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.NumDays    = 0;
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeAutoNamesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeIDByPartnerOfferTypeIDParams
    = function() {
    var params = { };

    params.HotelID            = 0;
    params.PartnerID          = 0;
    params.PartnerOfferTypeID = 0;
    params.RoomTypeID         = 0;
    params.MaxPersons         = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeIDByPartnerOfferTypeNameParams
    = function() {
    var params = { };

    params.HotelID              = 0;
    params.PartnerID            = 0;
    params.PartnerOfferTypeName = "";

    return params;
};

window.RQParam.PmsGetOfferTypeListenersParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeMemberDiscountDaysParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeMemberDiscountsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeMemberDiscountWindowParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.StartDate   = "Date";

    return params;
};

window.RQParam.PmsGetOfferTypeNameParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeNamesAllParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeNavigationDataParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsGetOfferTypePartnersParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetOfferTypesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetOfferTypesByPartnerParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeSharedAllotmentGroupsParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetOfferTypeSharedRateGroupsParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetPartnerParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;

    return params;
};

window.RQParam.PmsGetPartnerOfferTypeIDParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.PartnerID   = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetPartnersParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetPartnersWithPendingChannelActionsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetPaymentSchemesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetPaymentSchemesOTAParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetPendingChannelActionsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;

    return params;
};

window.RQParam.PmsGetPMSOverviewDataFullParams
    = function() {
    var params = { };

    params.HotelID                        = 0;
    params.OccStartDate                   = "Date";
    params.OccNumDays                     = 0;
    params.OccRoomTypeID                  = 0;
    params.MainReservationID              = 0;
    params.ResListStart                   = "Date";
    params.ResListEnd                     = "Date";
    params.ResListSearchTypeID            = 0;
    params.SearchFilterID                 = 0;
    params.SearchWithArr                  = 0;
    params.SearchArr                      = "Date";
    params.SearchWithDep                  = 0;
    params.SearchDep                      = "Date";
    params.SearchResID                    = 0;
    params.SearchExternalResID            = "";
    params.SearchPartnerID                = 0;
    params.SearchFirtName                 = "";
    params.SearchLastName                 = "";
    params.SearchEmail                    = "";
    params.AdvSearchExclusive             = 0;
    params.AdvSearchFilterID              = 0;
    params.AdvSearchShowPastRes           = 0;
    params.AdvSearchWithArr               = 0;
    params.AdvSearchArr                   = "Date";
    params.AdvSearchWithDep               = 0;
    params.AdvSearchDep                   = "Date";
    params.AdvSearchWithArrFrom           = 0;
    params.AdvSearchArrFrom               = "Date";
    params.AdvSearchWithArrUntil          = 0;
    params.AdvSearchArrUntil              = "Date";
    params.AdvSearchWithDepFrom           = 0;
    params.AdvSearchDepFrom               = "Date";
    params.AdvSearchWithDepUntil          = 0;
    params.AdvSearchDepUntil              = "Date";
    params.AdvSearchResID                 = 0;
    params.AdvSearchResStatus             = 0;
    params.AdvSearchExternalResID         = "";
    params.AdvSearchPartnerID             = 0;
    params.AdvSearchFirtName              = "";
    params.AdvSearchLastName              = "";
    params.AdvSearchEmail                 = "";
    params.AdvSearchNotePriorityLevel     = 0;
    params.AdvSearchPriorityNotes         = "";
    params.AdvSearchNotes                 = "";
    params.AdvSearchCountryID             = 0;
    params.AdvSearchPostCode              = "";
    params.AdvSearchLocation              = "";
    params.AdvSearchAddress               = "";
    params.AdvSearchIdentification        = "";
    params.AdvSearchPhone                 = "";
    params.AdvSearchMobile                = "";
    params.AdvSearchFax                   = "";
    params.CleaningRoomTypeID             = 0;
    params.CleaningTaskTypeID             = 0;
    params.CleaningExtraReservationTaskID = 0;
    params.CleaningCDay                   = "Date";
    params.CleaningOutstandingOnly        = 0;
    params.WithRateRefresh                = 0;
    params.RateRoomTypeID                 = 0;
    params.RateMaxPersons                 = 0;
    params.RateOfferTypeID                = 0;
    params.RateRackRatePeriodID           = 0;
    params.LangID                         = 0;

    return params;
};

window.RQParam.PmsGetPMSOverviewDataSlimParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.OccStartDate        = "Date";
    params.OccNumDays          = 0;
    params.OccRoomTypeID       = 0;
    params.MainReservationID   = 0;
    params.ResListStart        = "Date";
    params.ResListEnd          = "Date";
    params.ResListSearchTypeID = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsGetPMSOverviewRateDataParams
    = function() {
    var params = { };

    params.HotelID              = 0;
    params.RateRoomTypeID       = 0;
    params.RateMaxPersons       = 0;
    params.RateOfferTypeID      = 0;
    params.RateRackRatePeriodID = 0;
    params.LangID               = 0;

    return params;
};

window.RQParam.PmsGetPrimarySMTPServerParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetProjectedTurnoverParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.EndDate   = "Date";
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsGetProjectedTurnoverByPartnerParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.StartDate   = "Date";
    params.EndDate     = "Date";
    params.ChannelOnly = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsGetProjectedTurnoverTotalsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.EndDate   = "Date";

    return params;
};

window.RQParam.PmsGetRackRateChannelDataParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.PartnerID   = 0;
    params.RoomTypeID  = 0;
    params.MaxPersons  = 0;
    params.OfferTypeID = 0;
    params.arr         = "Date";
    params.end         = "Date";

    return params;
};

window.RQParam.PmsGetRackRatePeriodsWithMissingRateInfoParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.RoomTypeID  = 0;
    params.MaxPersons  = 0;

    return params;
};

window.RQParam.PmsGetRackRatesParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RackRatePeriodID = 0;
    params.RoomTypeID       = 0;
    params.MaxPersons       = 0;
    params.OfferTypeID      = 0;

    return params;
};

window.RQParam.PmsGetRatePeriodParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.OfferTypeID = 0;
    params.MaxPersons  = 0;
    params.StartDate   = "Date";
    params.EndDate     = "Date";
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsGetRatePeriodsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetReportsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsGetResDayCheckedInGuestsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.ResDay  = "Date";
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetReservationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetReservationChargesParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetReservationFullParams
    = function() {
    var params = { };

    params.HotelID                       = 0;
    params.ReservationID                 = 0;
    params.NewRoomResModeExplicitlySet   = 0;
    params.SelectedRoomReservationID     = 0;
    params.SelectedOfferTypeID           = 0;
    params.SelectedExclusiveRatePeriodID = 0;
    params.DefaultArr                    = "Date";
    params.DefaultDep                    = "Date";
    params.KeepRate                      = 0;
    params.ManualOverride                = 0;
    params.SelectedGuestID               = 0;
    params.SelectedAssignmentRoom        = 0;
    params.SelectedAccountID             = 0;
    params.SelectedTransactionID         = 0;
    params.TillID                        = 0;
    params.UserID                        = 0;
    params.LangID                        = 0;

    return params;
};

window.RQParam.PmsGetReservationGuestParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.GuestID       = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetReservationGuestsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetReservationIDByExternalReservationIDParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.PartnerID             = 0;
    params.ExternalReservationID = "";

    return params;
};

window.RQParam.PmsGetReservationListParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.StartDate    = "Date";
    params.EndDate      = "Date";
    params.SearchTypeID = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsGetReservationStatusesParams
    = function() {
    var params = { };

    params.ShowAll = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetRoomParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.RoomID  = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetRoomOccupancySummaryParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.Day     = "Date";
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetRoomPeriodNoteParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomPeriodNoteID = 0;

    return params;
};

window.RQParam.PmsGetRoomPeriodNoteByRoomIDAndPeriodParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.RoomID    = 0;
    params.StartDate = "Date";
    params.EndDate   = "Date";

    return params;
};

window.RQParam.PmsGetRoomPeriodNotesParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetRoomPeriodNotesByWindowParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.EndDate   = "Date";

    return params;
};

window.RQParam.PmsGetRoomReservationParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsGetRoomReservationArrivalGuestsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsGetRoomReservationBreakdownParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;

    return params;
};

window.RQParam.PmsGetRoomReservationsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsGetRoomReservationStatusesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetRoomsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetRoomsByRoomTypeIDParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeBaseNamesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeClassNamesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeIDByPartnerRoomTypeIDParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.PartnerID         = 0;
    params.PartnerRoomTypeID = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeIDByPartnerRoomTypeNameParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.PartnerID           = 0;
    params.PartnerRoomTypeName = "";

    return params;
};

window.RQParam.PmsGetRoomTypeMappingByPartnerParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeNameParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.RoomTypeNameID = "";
    params.LangID         = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeNamesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeNamesUnusedParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetRoomTypesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetRoomTypeStopSellDataParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.EndDate   = "Date";
    params.LangID    = 0;

    return params;
};

window.RQParam.PmsGetShiftLogParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.Days    = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetShiftsByBusinessDayParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.BusinessDay = "Date";
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsGetSMTPServerParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.SMTPServerID = 0;

    return params;
};

window.RQParam.PmsGetSMTPServersParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetSplittingDataParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsGetTemplateParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.TemplateID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsGetTemplatesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsGetThirdPartyModificationTimeParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.PmsGetTotalVisitorsPerCountryParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.Arr     = "Date";
    params.Dep     = "Date";

    return params;
};

window.RQParam.PmsGetTotalVisitorsPerCountryUnassignedParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.Arr     = "Date";
    params.Dep     = "Date";

    return params;
};

window.RQParam.PmsGetUnassignedGuestsForRoomReservationParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsGetUnassignedPartnersForOfferTypeParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsGetUserParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.UserID  = 0;

    return params;
};

window.RQParam.PmsGetUserActionsParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.PmsGetUsersParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsGetWuBookRCodesByReservationIDParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.PmsGrantProductAPIKeyParams
    = function() {
    var params = { };

    params.Email         = "";
    params.RequestTypeID = 0;

    return params;
};

window.RQParam.PmsHarnessTestParams
    = function() {
    var params = { };

    params.ParamInteger  = 0;
    params.ParamNVarChar = "";
    params.ParamDate     = "Date";
    params.ParamDecimal  = 0;
    params.ParamReal     = 0;

    return params;
};

window.RQParam.PmsHotelAcceptsOTAChannelUpdatesParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsHotelHasCacheDataParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsIndexLastMinuteDiscountsAllParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsIndexMixedRateHotelPeriodParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.EndDate   = "Date";

    return params;
};

window.RQParam.PmsInitOTAHotelCTMAccountParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsInspectRoomTypeActivityLogParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.RoomTypeID    = 0;
    params.StartDate     = "Date";
    params.EndDate       = "Date";
    params.NumDaysToShow = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsLoadFormElementTextTranslationsParams
    = function() {
    var params = { };

    params.LangID       = 0;
    params.WithFallback = 0;

    return params;
};

window.RQParam.PmsLoadGuiMessagesParams
    = function() {
    var params = { };

    params.LangID       = 0;
    params.WithFallback = 0;

    return params;
};

window.RQParam.PmsLoadReportTextsPivotedByIDParams
    = function() {
    var params = { };

    params.ReportID = 0;
    params.LangID   = 0;

    return params;
};

window.RQParam.PmsLogReservationCorrespondenceActionParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.ReservationID  = 0;
    params.LogActionID    = 0;
    params.TemplateID     = 0;
    params.TemplateLangID = 0;
    params.Subject        = "";
    params.Body           = "";
    params.UserID         = 0;
    params.LangID         = 0;

    return params;
};

window.RQParam.PmsMakeReservationParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.GuestID               = 0;
    params.ReservationStatusID   = 0;
    params.PartnerID             = 0;
    params.ExternalReservationID = "";
    params.ThirdParty            = 0;
    params.IsEngineBooking       = 0;
    params.UserID                = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsMakeReservationViaGatewayParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.GuestID               = 0;
    params.ReservationStatusID   = 0;
    params.PartnerID             = 0;
    params.ExternalReservationID = "";
    params.GatewayPartnerID      = 0;
    params.GatewayReservationID  = "";
    params.UserID                = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsMakeRoomReservationParams
    = function() {
    var params = { };

    params.HotelID                          = 0;
    params.ReservationID                    = 0;
    params.RoomID                           = 0;
    params.MaxPersons                       = 0;
    params.arr                              = "Date";
    params.dep                              = "Date";
    params.RoomReservationStatusID          = 0;
    params.OfferTypeID                      = 0;
    params.ExclusiveRatePeriodID            = 0;
    params.IsHoldUntil                      = 0;
    params.HoldUntil                        = "Date";
    params.OverridePrice                    = 0;
    params.OverrideWithTaxes                = 0;
    params.NumPersonsStaying                = 0;
    params.NumPersonsHavingBreakfast        = 0;
    params.OverridePaymentSchemeConsistency = 0;
    params.UserID                           = 0;
    params.LangID                           = 0;

    return params;
};

window.RQParam.PmsMakeRoomReservationGroupParams
    = function() {
    var params = { };

    params.HotelID                        = 0;
    params.ReservationID                  = 0;
    params.ExternalRoomReservationID      = "";
    params.RoomTypeID                     = 0;
    params.MaxPersons                     = 0;
    params.NumRooms                       = 0;
    params.arr                            = "Date";
    params.dep                            = "Date";
    params.RoomReservationStatusID        = 0;
    params.OfferTypeID                    = 0;
    params.ExclusiveRatePeriodID          = 0;
    params.DayPrice1                      = 0;
    params.DayPrice2                      = 0;
    params.DayPrice3                      = 0;
    params.DayPrice4                      = 0;
    params.DayPrice5                      = 0;
    params.DayPrice6                      = 0;
    params.DayPrice7                      = 0;
    params.DayPrice8                      = 0;
    params.DayPrice9                      = 0;
    params.DayPrice10                     = 0;
    params.DayPrice11                     = 0;
    params.DayPrice12                     = 0;
    params.DayPrice13                     = 0;
    params.DayPrice14                     = 0;
    params.DayPrice15                     = 0;
    params.DayPrice16                     = 0;
    params.DayPrice17                     = 0;
    params.DayPrice18                     = 0;
    params.DayPrice19                     = 0;
    params.DayPrice20                     = 0;
    params.DayPrice21                     = 0;
    params.DayPrice22                     = 0;
    params.DayPrice23                     = 0;
    params.DayPrice24                     = 0;
    params.DayPrice25                     = 0;
    params.DayPrice26                     = 0;
    params.DayPrice27                     = 0;
    params.DayPrice28                     = 0;
    params.SuppliedPrice                  = 0;
    params.PrePaidPartnerCommission       = 0;
    params.SuppliedGroupTotal             = 0;
    params.GroupTotalIsExclusive          = 0;
    params.SuppliedWithoutAdditionalTaxes = 0;
    params.ThirdParty                     = 0;
    params.Override                       = 0;
    params.LastGroup                      = 0;
    params.IsEngineChannelEdit            = 0;
    params.UserID                         = 0;
    params.LangID                         = 0;

    return params;
};

window.RQParam.PmsMakeRoomReservationGroupWithDiscountParams
    = function() {
    var params = { };

    params.HotelID                        = 0;
    params.ReservationID                  = 0;
    params.ExternalRoomReservationID      = "";
    params.RoomTypeID                     = 0;
    params.MaxPersons                     = 0;
    params.NumRooms                       = 0;
    params.arr                            = "Date";
    params.dep                            = "Date";
    params.RoomReservationStatusID        = 0;
    params.OfferTypeID                    = 0;
    params.ExclusiveRatePeriodID          = 0;
    params.DayPrice1                      = 0;
    params.DayPrice2                      = 0;
    params.DayPrice3                      = 0;
    params.DayPrice4                      = 0;
    params.DayPrice5                      = 0;
    params.DayPrice6                      = 0;
    params.DayPrice7                      = 0;
    params.DayPrice8                      = 0;
    params.DayPrice9                      = 0;
    params.DayPrice10                     = 0;
    params.DayPrice11                     = 0;
    params.DayPrice12                     = 0;
    params.DayPrice13                     = 0;
    params.DayPrice14                     = 0;
    params.DayPrice15                     = 0;
    params.DayPrice16                     = 0;
    params.DayPrice17                     = 0;
    params.DayPrice18                     = 0;
    params.DayPrice19                     = 0;
    params.DayPrice20                     = 0;
    params.DayPrice21                     = 0;
    params.DayPrice22                     = 0;
    params.DayPrice23                     = 0;
    params.DayPrice24                     = 0;
    params.DayPrice25                     = 0;
    params.DayPrice26                     = 0;
    params.DayPrice27                     = 0;
    params.DayPrice28                     = 0;
    params.SuppliedPrice                  = 0;
    params.PrePaidPartnerCommission       = 0;
    params.SuppliedGroupTotal             = 0;
    params.GroupTotalIsExclusive          = 0;
    params.SuppliedWithoutAdditionalTaxes = 0;
    params.ThirdParty                     = 0;
    params.Override                       = 0;
    params.LastGroup                      = 0;
    params.IsEngineChannelEdit            = 0;
    params.AllowDiscount                  = 0;
    params.UserID                         = 0;
    params.LangID                         = 0;

    return params;
};

window.RQParam.PmsMarkFormAsSeenParams
    = function() {
    var params = { };

    params.FormID = 0;

    return params;
};

window.RQParam.PmsMarkFormElementAsSeenParams
    = function() {
    var params = { };

    params.FormElementID = 0;

    return params;
};

window.RQParam.PmsMigrateRoomParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomID     = 0;
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsMonitorChannelManagerStatusParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsMonitorEmergencyPartnerDeactivationParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsNewExhibitionPeriodParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.start               = "Date";
    params.end                 = "Date";
    params.ExhibtionPeriodName = "";
    params.ColorID             = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsNewGuestParams
    = function() {
    var params = { };

    params.HotelID                = 0;
    params.GuestTitleID           = 0;
    params.Gender                 = 0;
    params.Minor                  = 0;
    params.FirstName              = "";
    params.LastName               = "";
    params.Company                = "";
    params.CompanyVAT             = "";
    params.CountryID              = 0;
    params.Address                = "";
    params.Location               = "";
    params.PostCode               = "";
    params.Telephone              = "";
    params.TelephoneAlt           = "";
    params.Mobile                 = "";
    params.Fax                    = "";
    params.EMail                  = "";
    params.BirthPlace             = "";
    params.DateOfBirth            = "Date";
    params.IdentificationTypeID   = 0;
    params.Identification         = "";
    params.NationalIDNo           = "";
    params.IDRegistrationCity     = "";
    params.IDRegistrationDistrict = "";
    params.TaxIdentification      = "";
    params.MothersName            = "";
    params.FathersName            = "";
    params.Occupation             = "";
    params.Notes                  = "";
    params.CCTypeID               = 0;
    params.CCNumber               = "";
    params.CCName                 = "";
    params.CCExpiryYear           = 0;
    params.CCExpiryMonth          = 0;
    params.CCCVC                  = "";
    params.ThirdParty             = 0;
    params.IsEngineGuest          = 0;
    params.UserID                 = 0;

    return params;
};

window.RQParam.PmsNewOfferTypeParams
    = function() {
    var params = { };

    params.HotelID                    = 0;
    params.RackRatePaymentSchemeID    = 0;
    params.Credentials                = "";
    params.ReleaseDays                = 0;
    params.CancelConsumesAvailability = 0;
    params.OfferTypeName              = "";
    params.OfferTypeDescription       = "";

    return params;
};

window.RQParam.PmsNewOfferTypeAsDiscountParams
    = function() {
    var params = { };

    params.HotelID                    = 0;
    params.RackRatePaymentSchemeID    = 0;
    params.Credentials                = "";
    params.ReleaseDays                = 0;
    params.CancelConsumesAvailability = 0;
    params.OfferTypeName              = "";
    params.OfferTypeDescription       = "";
    params.SourceOfferTypeID          = 0;
    params.DiscountTypeID             = 0;
    params.Surcharge                  = 0;
    params.SourceMLOS                 = 0;
    params.SourceMaxStay              = 0;
    params.SourceAdvanceDays          = 0;
    params.SourceNoArr                = 0;
    params.SourceNoDep                = 0;
    params.SourceMaxPersons           = 0;
    params.InitialiseAllotmentToZero  = 0;

    return params;
};

window.RQParam.PmsNewOfferTypeAsDiscountOTAParams
    = function() {
    var params = { };

    params.HotelID                    = 0;
    params.RackRatePaymentSchemeID    = 0;
    params.Credentials                = "";
    params.ReleaseDays                = 0;
    params.CancelConsumesAvailability = 0;
    params.OfferTypeName              = "";
    params.OfferTypeDescription       = "";
    params.OfferTypeAutoNameID        = 0;
    params.SourceOfferTypeID          = 0;
    params.DiscountTypeID             = 0;
    params.Surcharge                  = 0;
    params.SourceMLOS                 = 0;
    params.SourceMaxStay              = 0;
    params.SourceAdvanceDays          = 0;
    params.SourceNoArr                = 0;
    params.SourceNoDep                = 0;
    params.SourceMaxPersons           = 0;
    params.InitialiseAllotmentToZero  = 0;
    params.PackageLevelAdvanceDays    = 0;
    params.LangID                     = 0;

    return params;
};

window.RQParam.PmsNewOfferTypeOTAParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.PaymentSchemeID         = 0;
    params.OfferTypeName           = "";
    params.OfferTypeAutoNameID     = 0;
    params.PackageLevelAdvanceDays = 0;
    params.LangID                  = 0;

    return params;
};

window.RQParam.PmsNewPartnerParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.Partner                  = "";
    params.CommissionPercentage     = 0;
    params.CommissionPerReservation = 0;
    params.CommissionVAT            = 0;
    params.LangID                   = 0;

    return params;
};

window.RQParam.PmsNewRackRateParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RackRatePeriodID = 0;
    params.RoomTypeID       = 0;
    params.MaxPersons       = 0;
    params.OfferTypeID      = 0;
    params.Allotment        = 0;
    params.MonPrice         = 0;
    params.MonMLOS          = 0;
    params.MonMaxStay       = 0;
    params.MonAdvanceDays   = 0;
    params.MonNoArr         = 0;
    params.MonNoDep         = 0;
    params.TuePrice         = 0;
    params.TueMLOS          = 0;
    params.TueMaxStay       = 0;
    params.TueAdvanceDays   = 0;
    params.TueNoArr         = 0;
    params.TueNoDep         = 0;
    params.WedPrice         = 0;
    params.WedMLOS          = 0;
    params.WedMaxStay       = 0;
    params.WedAdvanceDays   = 0;
    params.WedNoArr         = 0;
    params.WedNoDep         = 0;
    params.ThuPrice         = 0;
    params.ThuMLOS          = 0;
    params.ThuMaxStay       = 0;
    params.ThuAdvanceDays   = 0;
    params.ThuNoArr         = 0;
    params.ThuNoDep         = 0;
    params.FriPrice         = 0;
    params.FriMLOS          = 0;
    params.FriMaxStay       = 0;
    params.FriAdvanceDays   = 0;
    params.FriNoArr         = 0;
    params.FriNoDep         = 0;
    params.SatPrice         = 0;
    params.SatMLOS          = 0;
    params.SatMaxStay       = 0;
    params.SatAdvanceDays   = 0;
    params.SatNoArr         = 0;
    params.SatNoDep         = 0;
    params.SunPrice         = 0;
    params.SunMLOS          = 0;
    params.SunMaxStay       = 0;
    params.SunAdvanceDays   = 0;
    params.SunNoArr         = 0;
    params.SunNoDep         = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsNewRackRatePeriodParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.start    = "Date";
    params.end      = "Date";
    params.Override = 0;
    params.LangID   = 0;

    return params;
};

window.RQParam.PmsNewRoomParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.RoomNumber = "";
    params.LangID     = 0;

    return params;
};

window.RQParam.PmsNewRoomPeriodNoteParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomID            = 0;
    params.StartDate         = "Date";
    params.EndDate           = "Date";
    params.NotePriorityLevel = 0;
    params.Notes             = "";
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsNewRoomTypeParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomTypeNameID   = 0;
    params.NrOfRooms        = 0;
    params.PersonsNormal    = 0;
    params.MaxPersonsNormal = 0;
    params.MinPrice         = 0;
    params.MaxPrice         = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsNewRoomTypeNameParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.RoomTypeName = "";
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsNewRoomTypeWithAutoNameParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomBaseID       = 0;
    params.RoomClassID      = 0;
    params.NrOfRooms        = 0;
    params.PersonsNormal    = 0;
    params.MaxPersonsNormal = 0;
    params.MinPrice         = 0;
    params.MaxPrice         = 0;
    params.FreeText         = "";
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsNewSMTPServerParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.Description    = "";
    params.ServerName     = "";
    params.Port           = 0;
    params.EnableSSL      = 0;
    params.UseCredentials = 0;
    params.Username       = "";
    params.Password       = "";
    params.IsPrimary      = 0;

    return params;
};

window.RQParam.PmsNewTemplateParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.LangID   = 0;
    params.Title    = "";
    params.Subject  = "";
    params.FileName = "";

    return params;
};

window.RQParam.PmsNewUserParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.UserName         = "";
    params.Credentials      = "";
    params.IsAdmin          = 0;
    params.CanCloseJournal  = 0;
    params.CanReopenJournal = 0;
    params.IsAuditor        = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.PmsNotifyParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.NotificationID    = 0;
    params.ReservationID     = 0;
    params.RoomReservationID = 0;
    params.RoomPeriodNoteID  = 0;
    params.PartnerID         = 0;

    return params;
};

window.RQParam.PmsNotifyChannelModDoubleChecksParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsNotifyOutstandingCheckoutsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsNotifyOutstandingOTAXMLActivationsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.PmsNotifyTodaysPriorityNotesParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsOTAXMLTestAccountViewAvailabilityParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.StartDate  = "Date";

    return params;
};

window.RQParam.PmsOTAXMLTestAccountViewRatesParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.OfferTypeID = 0;
    params.MaxPersons  = 0;
    params.StartDate   = "Date";

    return params;
};

window.RQParam.PmsPopulateOTAExternalRoomReservationIDsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.PmsProduceChannelManagerExceptionDigestParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsProduceDailyActionScheduleParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.ReportDay    = "Date";
    params.ShowCheckIns = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsProduceDailyExtraPaymentListParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.ReportDay    = "Date";
    params.ShowCheckIns = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.PmsProduceMonitorHeartbeatDigestParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.FromWhen = "Date";

    return params;
};

window.RQParam.PmsProducePMSExceptionDigestParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsProduceSyncTestHeartbeatDigestParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.FromWhen = "Date";

    return params;
};

window.RQParam.PmsPruneExpiredPartnersParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsRecordThirdPartyModificationTimeParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.ReservationID    = 0;
    params.ModificationTime = "Date";

    return params;
};

window.RQParam.PmsRegisterChannelManagerExceptionParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.PartnerID     = 0;
    params.InPull        = 0;
    params.ExceptionText = "";
    params.StackTrace    = "";
    params.Priority      = 0;

    return params;
};

window.RQParam.PmsRegisterChannelManagerExceptionsAlertedParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsRegisterMonitorHeartbeatInitParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsRegisterMonitorHeartbeatStatusParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.MonitorTickID = 0;
    params.MonitorStatus = 0;

    return params;
};

window.RQParam.PmsRegisterPMSExceptionParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.IPAddress     = "";
    params.ExceptionText = "";
    params.StackTrace    = "";
    params.Priority      = 0;

    return params;
};

window.RQParam.PmsRegisterPMSExceptionsAlertedParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsRegisterSyncTestHeartbeatInitParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsRegisterSyncTestHeartbeatStatusParams
    = function() {
    var params = { };

    params.HotelID                     = 0;
    params.SyncTestTickID              = 0;
    params.TimesPushQueueFoundNonEmpty = 0;
    params.TimesTestWasDeffered        = 0;
    params.MismatchDays                = 0;
    params.SyncTestStatus              = 0;

    return params;
};

window.RQParam.PmsRegisterThirdPartyEditFailureParams
    = function() {
    var params = { };

    params.HotelID                       = 0;
    params.ReservationID                 = 0;
    params.IsUnsupportedGroupBookingEdit = 0;

    return params;
};

window.RQParam.PmsReleaseOutOfOrderRoomParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.RoomID  = 0;
    params.begin   = "Date";
    params.end     = "Date";
    params.UserID  = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.PmsReportCancelConfirmedToThirdPartyParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.PmsReportChannelActionAttemptParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.ChannelActionID = 0;

    return params;
};

window.RQParam.PmsReportChannelActionSuccessParams
    = function() {
    var params = { };

    params.HotelID              = 0;
    params.ChannelActionID      = 0;
    params.PartnerResponseToken = "";

    return params;
};

window.RQParam.PmsReportChannelPullParams
    = function() {
    var params = { };

    params.HotelID              = 0;
    params.PartnerID            = 0;
    params.PartnerResponseToken = "";

    return params;
};

window.RQParam.PmsReportChannelUpdateCycleParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;

    return params;
};

window.RQParam.PmsReportResConfirmedToThirdPartyParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.PmsRequestProductAPIKeyParams
    = function() {
    var params = { };

    params.Email         = "";
    params.RequestTypeID = 0;

    return params;
};

window.RQParam.PmsRestoreRackRatesParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomTypeID  = 0;
    params.MaxPersons  = 0;
    params.OfferTypeID = 0;
    params.start       = "Date";
    params.end         = "Date";
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsRetrieveCorrespondenceActionParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LogEventID    = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsRetrieveOTAReservationsParams
    = function() {
    var params = { };

    params.HotelID                   = 0;
    params.DaysInPast                = 0;
    params.ExternalRoomReservationID = "";
    params.WithStatus                = 0;
    params.Pending                   = 0;
    params.Retrieved                 = 0;
    params.Confirmed                 = 0;

    return params;
};

window.RQParam.PmsRetrieveOTAReservationsCancelParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsRetrieveOTAReservationsModifyParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsRetrieveOTAReservationsNewParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsRetrieveReservationActionsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.Debug         = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsRetrieveReservationCorrespondenceActionsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.PmsSaveFormElementTextParams
    = function() {
    var params = { };

    params.FormElementID   = 0;
    params.FormElementText = "";

    return params;
};

window.RQParam.PmsScheduleChannelActionsByRoomTypeParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.LogEventID = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.CloseOut   = 0;

    return params;
};

window.RQParam.PmsScheduleCompleteRateActionSyncParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;

    return params;
};

window.RQParam.PmsSearchGuestsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.Exclusive         = 0;
    params.FirstName         = "";
    params.LastName          = "";
    params.Gender            = 0;
    params.Company           = "";
    params.CountryID         = 0;
    params.Address           = "";
    params.Location          = "";
    params.PostCode          = "";
    params.TelePhone         = "";
    params.Fax               = "";
    params.EMail             = "";
    params.Identification    = "";
    params.TaxIdentification = "";
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsSearchReservationsParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.ShowPastReservations  = 0;
    params.ShowCheckIn           = 0;
    params.ShowCheckOut          = 0;
    params.ShowOnGoing           = 0;
    params.BrokenResOnly         = 0;
    params.HoldUntilOnly         = 0;
    params.PriorityNotesOnly     = 0;
    params.SameDayCheckoutsOnly  = 0;
    params.Exclusive             = 0;
    params.ReservationID         = 0;
    params.ReservationStatusID   = 0;
    params.ExternalReservationID = "";
    params.Arrival               = "Date";
    params.Departure             = "Date";
    params.FirstName             = "";
    params.LastName              = "";
    params.Email                 = "";
    params.PartnerID             = 0;
    params.NotePriorityLevel     = 0;
    params.PriorityNotes         = "";
    params.Notes                 = "";
    params.ArrivalFrom           = "Date";
    params.ArrivalUntil          = "Date";
    params.DepartureFrom         = "Date";
    params.DepartureUntil        = "Date";
    params.CountryID             = 0;
    params.PostCode              = "";
    params.Location              = "";
    params.Address               = "";
    params.Identification        = "";
    params.Phone                 = "";
    params.Mobile                = "";
    params.Fax                   = "";
    params.LangID                = 0;

    return params;
};

window.RQParam.PmsSetBookingDotComDeviceCookieParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.DeviceLocationID = 0;
    params.Name             = "";
    params.Value            = "";
    params.Expires          = "Date";

    return params;
};

window.RQParam.PmsSetExternalRoomReservationIDParams
    = function() {
    var params = { };

    params.HotelID                   = 0;
    params.RoomReservationID         = 0;
    params.ExternalRoomReservationID = "";

    return params;
};

window.RQParam.PmsSetGuestTouristFeeExemptionParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.GuestID  = 0;
    params.IsExempt = 0;

    return params;
};

window.RQParam.PmsSetOfferTypeMemberDiscountParams
    = function() {
    var params = { };

    params.HotelID            = 0;
    params.OfferTypeID        = 0;
    params.AllowDiscount      = 0;
    params.DiscountPercentage = 0;
    params.LangID             = 0;

    return params;
};

window.RQParam.PmsSetOfferTypeMemberDiscountDaysParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.StartDate   = "Date";
    params.EndDate     = "Date";
    params.Blocked     = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsSetReservationStatusParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.PmsSetRoomReservationNoShowParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.CancellationFee   = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsShuffleRoomOrderParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.SortOrderBegin = 0;
    params.SortOrderEnd   = 0;
    params.Up             = 0;
    params.LangID         = 0;

    return params;
};

window.RQParam.PmsShuffleRoomTypeOrderParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.SortOrderBegin = 0;
    params.SortOrderEnd   = 0;
    params.Up             = 0;
    params.LangID         = 0;

    return params;
};

window.RQParam.PmsSignalEmergencyPartnerDeactivationParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.PartnerID = 0;

    return params;
};

window.RQParam.PmsSyncCachesToConfigParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsUnassignGuestFromReservationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.GuestID       = 0;
    params.UserID        = 0;

    return params;
};

window.RQParam.PmsUnassignGuestFromRoomByRoomReservationParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.GuestID           = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsUnassignPartnerFromChannelParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.PartnerID   = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsUndoRoomReservationCheckInParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsUndoRoomReservationCheckOutParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsUndoRoomReservationNoShowParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsUpdateWuBookRCodesParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.WuBookRCode   = 0;
    params.Cancelled     = 0;

    return params;
};

window.RQParam.PmsValidateCheckInParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsValidateCheckOutParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsValidateNoShowParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.PmsValidateRoomResGroupRequestParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.PartnerID   = 0;
    params.RoomTypeID  = 0;
    params.OfferTypeID = 0;
    params.MaxPersons  = 0;
    params.arr         = "Date";
    params.dep         = "Date";
    params.LangID      = 0;

    return params;
};

window.RQParam.PmsVerifyCacheCoverageParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsVerifyNoRecentOverbookingsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsVerifyNotificationEventParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.NotificationEventID = 0;
    params.UserID              = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.PmsVerifyNotificationEventsByReservationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.UserID        = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.PmsVerifyNotificationEventsByReservationIDParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.UserID        = 0;

    return params;
};

window.RQParam.PmsVerifyRackRateAllotmentClampingParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsVerifyRackRateCapacityConsistencyParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;

    return params;
};

window.RQParam.PmsVerifyRackRateDayCoverageParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsVerifyRoomAvailabilityConsistencyParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsVerifyRoomResAssignmentConsistencyParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsVerifyRoomResBreakdownConsistencyParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsVerifyRoomResBreakdownMissingOKParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.PmsVerifyThirdPartyEditConsistencyParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.AccountsAddBillingSnapshotGuestParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;
    params.GuestID           = 0;
    params.IsBillingHolder   = 0;

    return params;
};

window.RQParam.AccountsAddCustomerInvoiceGuestParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerInvoiceID = 0;
    params.GuestID           = 0;
    params.IsInvoiceHolder   = 0;

    return params;
};

window.RQParam.AccountsCloseBillParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.BillingID     = 0;
    params.ClosingUserID = 0;
    params.Comment       = "";
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsCloseFolioBillParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.FolioID = 0;
    params.TillID  = 0;
    params.UserID  = 0;
    params.Comment = "";
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsCloseJournalSegmentParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TillID        = 0;
    params.UserID        = 0;
    params.ClosingUserID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsClosePMSBillParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.TillID        = 0;
    params.UserID        = 0;
    params.Comment       = "";
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsClosePOSBillParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;
    params.TillID    = 0;
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsCounterPOSBillParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;
    params.TillID    = 0;
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsCreateCounterInvoiceParams
    = function() {
    var params = { };

    params.HotelID                    = 0;
    params.InvoiceID                  = 0;
    params.UserID                     = 0;
    params.FromCounterCustomerInvoice = 0;
    params.LangID                     = 0;

    return params;
};

window.RQParam.AccountsCreateCustomerInvoiceParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;
    params.ProForma  = 0;
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsDeleteProductParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ProductID = 0;

    return params;
};

window.RQParam.AccountsDeleteTransactionParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TransactionID = 0;
    params.UserID        = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsEditFolioDetailsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.FolioID   = 0;
    params.GuestID   = 0;
    params.ToCompany = 0;
    params.Comment   = "";
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsEditProductParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.ProductID             = 0;
    params.Product               = "";
    params.AccountID             = 0;
    params.Amount                = 0;
    params.ProductBillingGroupID = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.AccountsEditTransactionParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TransactionID = 0;
    params.FolioID       = 0;
    params.Description   = "";
    params.Quantity      = 0;
    params.AmountPerUnit = 0;
    params.EditingTillID = 0;
    params.GuestID       = 0;
    params.UserID        = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetAccountParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.AccountID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsGetAccountsParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.ShowRoomCharges = 0;
    params.LangID          = 0;

    return params;
};

window.RQParam.AccountsGetAccountTypesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.AccountsGetActivePaymentTillsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.AccountsGetAllProductsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailBillResnapshotAggregatesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailBillResnapshotDataParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailCounterInvoiceAggregatesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailCounterInvoiceDataParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailCounterReceiptAggregatesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailCounterReceiptDataParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailRefundAggregatesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailRefundDataParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailSegmentResnapshotAggregatesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetAuditTrailSegmentResnapshotDataParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.ShowSystem = 0;

    return params;
};

window.RQParam.AccountsGetBalanceSummaryChargesParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetBillingBalanceParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;

    return params;
};

window.RQParam.AccountsGetBillingBalanceTotalOnlyParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;

    return params;
};

window.RQParam.AccountsGetBillingGuestNameParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotAncillaryGuestsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotBalanceParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotInvoiceAccountsParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.BillingSnapshotID       = 0;
    params.ShowRoomChargeBreakdown = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotInvoiceChargesParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;
    params.AggregateCharges  = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotInvoicesParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotInvoiceTaxesParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotReceiptAccountsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotReceiptPaymentsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;
    params.AggregateCharges  = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotReceiptsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetBillingSnapshotsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;

    return params;
};

window.RQParam.AccountsGetBillingStatusParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;

    return params;
};

window.RQParam.AccountsGetBillingTransactionsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsGetBillsParams
    = function() {
    var params = { };

    params.HotelID              = 0;
    params.TillID               = 0;
    params.UserID               = 0;
    params.ShowFrom             = "Date";
    params.ShowClosed           = 0;
    params.ShowReservationBills = 0;

    return params;
};

window.RQParam.AccountsGetBreakfastSummaryParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.StartDay = "Date";

    return params;
};

window.RQParam.AccountsGetChargeAccountsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsGetCurrentJournalSegmentSnapshotIDParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.JournalSegmentID = 0;

    return params;
};

window.RQParam.AccountsGetCurrentSegmentStartDayParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.AccountsGetCustomerInvoicableTransactionsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetCustomerInvoiceParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerInvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetCustomerInvoiceAccountsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerInvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetCustomerInvoiceAncillaryGuestsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerInvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetCustomerInvoiceBreakdownAndAccountsParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.CustomerInvoiceID       = 0;
    params.ShowRoomChargeBreakdown = 0;

    return params;
};

window.RQParam.AccountsGetCustomerInvoiceGuestNameParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerInvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetCustomerInvoiceRoomTypeBreakdownParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerInvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetFolioTransactionsParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.ReservationID       = 0;
    params.FolioID             = 0;
    params.ShowExpiredCharges  = 0;
    params.ShowExpiredPayments = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.AccountsGetInvoicableTransactionsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetInvoiceParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.InvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetInvoiceAccountsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.InvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetInvoiceBreakdownAndAccountsParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.InvoiceID               = 0;
    params.ShowRoomChargeBreakdown = 0;

    return params;
};

window.RQParam.AccountsGetInvoiceGuestNameParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.InvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetInvoiceRoomTypeBreakdownParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.InvoiceID = 0;

    return params;
};

window.RQParam.AccountsGetJournalPeriodSnapshotBillingGroupsParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.StartJournalSegmentID = 0;
    params.EndJournalSegmentID   = 0;
    params.ClosedBills           = 0;
    params.OngoingBills          = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.AccountsGetJournalPeriodSnapshotChargesParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.StartJournalSegmentID = 0;
    params.EndJournalSegmentID   = 0;
    params.ClosedBills           = 0;
    params.OngoingBills          = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.JournalSegmentID = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentEndTimesByDayParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ReportDay = "Date";

    return params;
};

window.RQParam.AccountsGetJournalSegmentsByTillParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.TillID         = 0;
    params.UserID         = 0;
    params.ShowRecentOnly = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentSnapshotParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.JournalSegmentSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentSnapshotBillingGroupsParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.JournalSegmentSnapshotID = 0;
    params.ClosedBills              = 0;
    params.OngoingBills             = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentSnapshotChargesParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.JournalSegmentSnapshotID = 0;
    params.ClosedBills              = 0;
    params.OngoingBills             = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentSnapshotClosedPaymentsParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.JournalSegmentSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentSnapshotOpenPaymentsParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.JournalSegmentSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentSnapshotsParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.JournalSegmentID = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentSnapshotSalesBillingGroupsParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.JournalSegmentSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentSnapshotSalesChargesParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.JournalSegmentSnapshotID = 0;

    return params;
};

window.RQParam.AccountsGetJournalSegmentStartTimesByDayParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ReportDay = "Date";

    return params;
};

window.RQParam.AccountsGetOccupiedRoomsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsGetPaymentAccountsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsGetPaymentGuestsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TransactionID = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetPrimaryReservationBillingIDParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.AccountsGetProductParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ProductID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsGetProductBillingGroupsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsGetProductsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.AccountID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsGetProductsByTypeParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.TypeID  = 0;

    return params;
};

window.RQParam.AccountsGetProvisionalBillingBalanceParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;

    return params;
};

window.RQParam.AccountsGetReceiptParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ReceiptID = 0;

    return params;
};

window.RQParam.AccountsGetReceiptAccountsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ReceiptID = 0;

    return params;
};

window.RQParam.AccountsGetReceiptGuestNameParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ReceiptID = 0;

    return params;
};

window.RQParam.AccountsGetReceiptInvoiceAccountsParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.ReceiptID               = 0;
    params.ShowRoomChargeBreakdown = 0;

    return params;
};

window.RQParam.AccountsGetReceiptInvoiceChargesParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.ReceiptID        = 0;
    params.AggregateCharges = 0;

    return params;
};

window.RQParam.AccountsGetReceiptInvoiceTaxesParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ReceiptID = 0;

    return params;
};

window.RQParam.AccountsGetReceiptPaymentsParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.ReceiptID         = 0;
    params.AggregatePayments = 0;

    return params;
};

window.RQParam.AccountsGetRegisterablePaymentsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.TillID        = 0;
    params.UserID        = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetReleasableTransactionsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetReservationBalanceParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.AccountsGetReservationBillingStatusParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.AccountsGetReservationBillsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetReservationCustomerInvoicesParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.AccountsGetReservationFoliosParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetReservationInclusiveRoomTotalParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.AccountsGetReservationInvoicesParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.AccountsGetReservationReceiptsParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.AccountsGetReservationTransactionsParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.ReservationID       = 0;
    params.ShowExpiredCharges  = 0;
    params.ShowExpiredPayments = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.AccountsGetRevenuePeriodAggregatesParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.StartJournalSegmentDate = "Date";
    params.EndJournalSegmentDate   = "Date";
    params.LangID                  = 0;

    return params;
};

window.RQParam.AccountsGetRevenuePeriodChargeBreakdownParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.StartJournalSegmentDate = "Date";
    params.EndJournalSegmentDate   = "Date";
    params.LangID                  = 0;

    return params;
};

window.RQParam.AccountsGetRevenuePeriodChargesParams
    = function() {
    var params = { };

    params.HotelID                 = 0;
    params.StartJournalSegmentDate = "Date";
    params.EndJournalSegmentDate   = "Date";
    params.LangID                  = 0;

    return params;
};

window.RQParam.AccountsGetRoomReservationAdditionalTaxTotalParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;

    return params;
};

window.RQParam.AccountsGetRoomReservationListParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetRoomServiceChargesParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.AccountsGetTaxParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.TaxID   = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsGetTaxesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsGetTillParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.TillID  = 0;

    return params;
};

window.RQParam.AccountsGetTillsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.AccountsGetTotalIntervalTurnoverParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.StartDateTime = "Date";
    params.EndDateTime   = "Date";
    params.AccountID     = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetTotalPeriodCommissionParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StartDate = "Date";
    params.EndDate   = "Date";

    return params;
};

window.RQParam.AccountsGetTotalPeriodTurnoverParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.FirstBusinessDay = "Date";
    params.LastBusinessDay  = "Date";
    params.AccountID        = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.AccountsGetTransactionParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TransactionID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsGetTransactionHistoryParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TransactionID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsInspectPeriodDeferrmentsParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.FirstBusinessDay = "Date";
    params.LastBusinessDay  = "Date";

    return params;
};

window.RQParam.AccountsInspectShiftDeferrmentsParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.ShiftID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.AccountsIssueCounterCustomerInvoiceParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerInvoiceID = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.AccountsIssueCounterInvoiceParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.InvoiceID = 0;
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsIssueCounterReceiptParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.ReceiptID = 0;
    params.TillID    = 0;
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsIssueCustomerInvoiceParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;
    params.ProForma  = 0;
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsIssueInvoiceParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.BillingID = 0;
    params.ProForma  = 0;
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsIssueReceiptParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.BillingID   = 0;
    params.FromJournal = 0;
    params.TillID      = 0;
    params.UserID      = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.AccountsMarkTransactionForBillingSplitParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TransactionID = 0;
    params.ToSplit       = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsMonitorJournalIntegrityParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.AccountsNewBillingTransactionParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.TillID    = 0;
    params.BillingID = 0;
    params.ProductID = 0;
    params.Quantity  = 0;
    params.Price     = 0;
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsNewFolioTransactionParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RevenueDay        = "Date";
    params.ReservationID     = 0;
    params.RoomReservationID = 0;
    params.FolioID           = 0;
    params.ProductID         = 0;
    params.AccountID         = 0;
    params.Description       = "";
    params.Quantity          = 0;
    params.AmountPerUnit     = 0;
    params.AllowRoomCharge   = 0;
    params.TillID            = 0;
    params.GuestID           = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.AccountsNewPOSPaymentParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.BillingID  = 0;
    params.AccountID  = 0;
    params.PaidAmount = 0;
    params.TillID     = 0;
    params.UserID     = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.AccountsNewProductParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.Product               = "";
    params.AccountID             = 0;
    params.Amount                = 0;
    params.ProductBillingGroupID = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.AccountsNewReservationFolioParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;
    params.GuestID       = 0;
    params.ToCompany     = 0;
    params.Comment       = "";
    params.UserID        = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsNewRoomServiceTransactionParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.ProductID         = 0;
    params.Quantity          = 0;
    params.Price             = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.AccountsNewServiceBillParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.BillingName = "";
    params.UserID      = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.AccountsNewTransactionParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RevenueDay        = "Date";
    params.ReservationID     = 0;
    params.RoomReservationID = 0;
    params.ProductID         = 0;
    params.AccountID         = 0;
    params.Description       = "";
    params.Quantity          = 0;
    params.AmountPerUnit     = 0;
    params.AllowRoomCharge   = 0;
    params.TillID            = 0;
    params.JournalSegmentID  = 0;
    params.OnBehalfOfUserID  = 0;
    params.Handled           = "Date";
    params.GuestID           = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.AccountsPreviewJournalSegmentParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TillID        = 0;
    params.UserID        = 0;
    params.ClosingUserID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsProduceJournalIntervalTurnoverReportParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.StartJournalSegmentID = 0;
    params.EndJournalSegmentID   = 0;
    params.WithUsers             = 0;
    params.AccountID             = 0;
    params.UserID                = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.AccountsProduceJournalIntervalTurnoverReportWithResBreakdownParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.StartJournalSegmentID = 0;
    params.EndJournalSegmentID   = 0;
    params.AccountID             = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.AccountsProducePeriodTurnoverReportParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.FirstBusinessDay = "Date";
    params.LastBusinessDay  = "Date";
    params.WithUsers        = 0;
    params.AccountID        = 0;
    params.UserID           = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.AccountsProducePeriodTurnoverReportWithResBreakdownParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.FirstBusinessDay = "Date";
    params.LastBusinessDay  = "Date";
    params.AccountID        = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.AccountsReCloseBillParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.BillingID     = 0;
    params.ClosingUserID = 0;
    params.Comment       = "";
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsReCloseBillAndSegmentParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.BillingID     = 0;
    params.TillID        = 0;
    params.ClosingUserID = 0;
    params.Comment       = "";
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsReCloseJournalSegmentParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.JournalSegmentID = 0;
    params.ClosingUserID    = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.AccountsReOpenBillParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.UserID    = 0;
    params.BillingID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsReOpenBillAndSegmentParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.UserID    = 0;
    params.BillingID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.AccountsReOpenJournalSegmentParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.UserID           = 0;
    params.JournalSegmentID = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.AccountsSaveCustomerInvoiceCommentParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerInvoiceID = 0;
    params.Comment           = "";

    return params;
};

window.RQParam.AccountsSetTransactionActiveStatusParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.TransactionID = 0;
    params.ActiveStatus  = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.AccountsSetTransactionInvoicingStatusParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.TransactionID   = 0;
    params.InvoicingStatus = 0;

    return params;
};

window.RQParam.AccountsSplitIntoNewBillParams
    = function() {
    var params = { };

    params.HotelID            = 0;
    params.SplitFromBillingID = 0;
    params.NewBillingName     = "";
    params.UserID             = 0;
    params.LangID             = 0;

    return params;
};

window.RQParam.AccountsTransferBillToRoomParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.BillingID         = 0;
    params.RoomReservationID = 0;
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.TasksAssignTaskToStaffMemberParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.UserID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksChangeRoomCleanStatusParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomID            = 0;
    params.RoomCleanStatusID = 0;
    params.UserID            = 0;
    params.StaffID           = 0;

    return params;
};

window.RQParam.TasksChangeRoomOccupancyStatusParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.RoomID                = 0;
    params.RoomOccupancyStatusID = 0;
    params.UserID                = 0;
    params.StaffID               = 0;

    return params;
};

window.RQParam.TasksChangeTaskPriorityParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.UserID     = 0;
    params.PriorityID = 0;

    return params;
};

window.RQParam.TasksDeleteStaffParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.StaffID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.TasksEditStaffPINParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.StaffID = 0;
    params.PIN     = "";
    params.UserID  = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.TasksExtGetAllRoomCleaningTasksParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.RoomTypeID    = 0;
    params.CDay          = "Date";
    params.OrderByStatus = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.TasksExtSetRoomCleaningTaskStateParams
    = function() {
    var params = { };

    params.HotelID                = 0;
    params.RoomID                 = 0;
    params.CDay                   = "Date";
    params.TaskTypeID             = 0;
    params.ExtraReservationTaskID = 0;
    params.UserID                 = 0;

    return params;
};

window.RQParam.TasksGetCleaningTasksStaffDataParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.StaffID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksGetCleaningTasksStaffSummaryParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.StaffID    = 0;
    params.StartDate  = "Date";
    params.EndDate    = "Date";
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksGetCleaningTaskTypesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.TasksGetCleaningTaskWorkflowConfigParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.TasksGetClearMakeUpRoomConfigParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.TasksGetExtraReservationTaskMenuParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksGetHandledStatusesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.TasksGetLocationDayCleaningTasksParams
    = function() {
    var params = { };

    params.HotelID                = 0;
    params.RoomTypeID             = 0;
    params.LocationID             = 0;
    params.TaskTypeID             = 0;
    params.ExtraReservationTaskID = 0;
    params.CDay                   = "Date";
    params.OutstandingOnly        = 0;
    params.LangID                 = 0;

    return params;
};

window.RQParam.TasksGetLocationDayTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksGetLocationDayTaskHistoryParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksGetReservationByRoomKeyParamsParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomNumber  = "";
    params.MoveInDate  = "Date";
    params.MoveOutDate = "Date";

    return params;
};

window.RQParam.TasksGetRoomDoNotDisturbStatusesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.TasksGetRoomDoNotDisturbStatusIDParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.RoomID  = 0;

    return params;
};

window.RQParam.TasksGetRoomKeyConfigByAPIKeyParams
    = function() {
    var params = { };

    params.APIKey = "";

    return params;
};

window.RQParam.TasksGetRoomKeyIssueParametersParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;

    return params;
};

window.RQParam.TasksGetRoomKeyIssuesByRoomReservationIDParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;

    return params;
};

window.RQParam.TasksGetStaffParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.TasksGetStaffAssignedDayCleaningTasksParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.StaffID         = 0;
    params.CDay            = "Date";
    params.OutstandingOnly = 0;
    params.LangID          = 0;

    return params;
};

window.RQParam.TasksGetTaskChecklistItemParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.LocationID      = 0;
    params.CDay            = "Date";
    params.TaskID          = 0;
    params.ChecklistItemID = 0;
    params.LangID          = 0;

    return params;
};

window.RQParam.TasksGetTaskChecklistItemsParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksGetTaskDataWindowParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.StartDate  = "Date";
    params.NumDays    = 0;
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksGetTaskMissingChecklistItemsParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksGetTaskPrioritiesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.TasksGuestAlterExtraReservationTaskParams
    = function() {
    var params = { };

    params.HotelID              = 0;
    params.LocationID           = 0;
    params.CDay                 = "Date";
    params.RequestedExtraTaskID = 0;
    params.LangID               = 0;

    return params;
};

window.RQParam.TasksGuestChangeRoomDoNotDisturbStatusParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.RoomID                   = 0;
    params.RoomDoNotDisturbStatusID = 0;
    params.LangID                   = 0;

    return params;
};

window.RQParam.TasksHandleCleaningStaffShiftEndParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.TasksIssueRoomKeyParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;
    params.GuestID           = 0;
    params.GuestName         = "";
    params.UserID            = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.TasksNewStaffParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.StaffName = "";
    params.PIN       = "";
    params.UserID    = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.TasksNotifyOutstandingCTMActivationsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.TasksPumpAllMissingGuestMoveNotificationsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.TasksQuickCloseCleaningTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.UserID     = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksReceptionChangeRoomDoNotDisturbStatusParams
    = function() {
    var params = { };

    params.HotelID                  = 0;
    params.RoomID                   = 0;
    params.RoomDoNotDisturbStatusID = 0;
    params.UserID                   = 0;
    params.LangID                   = 0;

    return params;
};

window.RQParam.TasksReturnRoomKeyParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.RoomNumber  = "";
    params.MoveInDate  = "Date";
    params.MoveOutDate = "Date";
    params.UserID      = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.TasksStaffMemberCheckAllItemsParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.LocationID     = 0;
    params.CDay           = "Date";
    params.TaskID         = 0;
    params.StaffID        = 0;
    params.IncludeMissing = 0;
    params.LangID         = 0;

    return params;
};

window.RQParam.TasksStaffMemberClearRoomBusyHintParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberCloseCleaningTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberCloseExtraReservationTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberCloseTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberOpenCleaningTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberOpenExtraReservationTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberOpenTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberSetChecklistItemMissingParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.LocationID      = 0;
    params.CDay            = "Date";
    params.TaskID          = 0;
    params.ChecklistItemID = 0;
    params.StaffID         = 0;
    params.LangID          = 0;

    return params;
};

window.RQParam.TasksStaffMemberSetChecklistItemStateParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.LocationID      = 0;
    params.CDay            = "Date";
    params.TaskID          = 0;
    params.ChecklistItemID = 0;
    params.Checked         = 0;
    params.StaffID         = 0;
    params.LangID          = 0;

    return params;
};

window.RQParam.TasksStaffMemberSetRoomBusyHintParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberUncheckAllItemsParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberUndoCloseCleaningTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberUndoCloseExtraReservationTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberUndoCloseTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberUndoOpenCleaningTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberUndoOpenExtraReservationTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.TasksStaffMemberUndoOpenTaskParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.LocationID = 0;
    params.CDay       = "Date";
    params.TaskID     = 0;
    params.StaffID    = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.OtaActivateHotelAccountFromNearbyPlaceParams
    = function() {
    var params = { };

    params.GPlaceID          = "";
    params.LocationGeoCodeID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.OtaAddgplaceParams
    = function() {
    var params = { };

    params.LocationGeoCodeID           = 0;
    params.place_id                    = "";
    params.lat                         = 0;
    params.lng                         = 0;
    params.country                     = "";
    params.locality                    = "";
    params.sublocality                 = "";
    params.colloquial_area             = "";
    params.neighborhood                = "";
    params.premise                     = "";
    params.postal_code                 = "";
    params.natural_feature             = "";
    params.airport                     = "";
    params.park                        = "";
    params.point_of_interest           = "";
    params.tourist_attraction          = "";
    params.administrative_area_level_1 = "";
    params.administrative_area_level_2 = "";
    params.administrative_area_level_3 = "";
    params.administrative_area_level_4 = "";
    params.administrative_area_level_5 = "";

    return params;
};

window.RQParam.OtaAddGPlaceFromNearbyPlaceParams
    = function() {
    var params = { };

    params.place_id                    = "";
    params.lat                         = 0;
    params.lng                         = 0;
    params.country                     = "";
    params.country_short               = "";
    params.locality                    = "";
    params.sublocality                 = "";
    params.colloquial_area             = "";
    params.neighborhood                = "";
    params.premise                     = "";
    params.postal_code                 = "";
    params.natural_feature             = "";
    params.airport                     = "";
    params.park                        = "";
    params.point_of_interest           = "";
    params.tourist_attraction          = "";
    params.administrative_area_level_1 = "";
    params.administrative_area_level_2 = "";
    params.administrative_area_level_3 = "";
    params.administrative_area_level_4 = "";
    params.administrative_area_level_5 = "";

    return params;
};

window.RQParam.OtaAddHotelDocParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.LangID      = 0;
    params.DocTypeID   = 0;
    params.FileName    = "";
    params.Description = "";

    return params;
};

window.RQParam.OtaAddHotelMapParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.FileName      = "";
    params.DescriptionEN = "";

    return params;
};

window.RQParam.OtaAddHotelPhotoParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.FileName      = "";
    params.DescriptionEN = "";

    return params;
};

window.RQParam.OtaAssignHotelPhotoToRoomTypeParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.HotelPhotoID = 0;
    params.RoomTypeID   = 0;

    return params;
};

window.RQParam.OtaAssignHotelToChainParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.HotelChainID = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.OtaBuildHotelRatingsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaBuildSearchLocationsParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaCheckHotelConfigParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaClearSubPayPeriodParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.PeriodYear  = 0;
    params.PeriodMonth = 0;
    params.StripeID    = "";

    return params;
};

window.RQParam.OtaCorres_GetSelectedHotelCorParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaCorresGetSelectedHotelCorParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaCorresInsertCorrLetterParams
    = function() {
    var params = { };

    params.Hotelid    = 0;
    params.EmployeeID = 0;
    params.Sender     = "";
    params.Recipient  = "";
    params.subject    = "";
    params.body       = "";

    return params;
};

window.RQParam.OtaDeleteHotelDocParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.DocID   = 0;

    return params;
};

window.RQParam.OtaDeleteHotelMapParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.HotelMapID = 0;

    return params;
};

window.RQParam.OtaDeleteHotelPhotoParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.HotelPhotoID = 0;

    return params;
};

window.RQParam.OtaDeleteLocationGeoCodeParams
    = function() {
    var params = { };

    params.LocationGeoCodeID = 0;

    return params;
};

window.RQParam.OtaEditHotelChainInfoParams
    = function() {
    var params = { };

    params.HotelChainID      = 0;
    params.ChainName         = "";
    params.ChainEmailGeneral = "";
    params.ChainURL          = "";
    params.ChainLogin        = "";
    params.CCPFirstName      = "";
    params.CCPLastName       = "";
    params.CCPGender         = 0;
    params.CCPFunction       = "";
    params.CCPTelephone      = "";
    params.CCPEmail          = "";
    params.CCPFax            = "";
    params.LangID            = 0;

    return params;
};

window.RQParam.OtaEditHotelChainPasswordParams
    = function() {
    var params = { };

    params.HotelChainID = 0;
    params.Password     = "";
    params.LangID       = 0;

    return params;
};

window.RQParam.OtaEditHotelDescriptionParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.Description = "";
    params.LangID      = 0;

    return params;
};

window.RQParam.OtaEditHotelDetailsParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.HotelName           = "";
    params.CPFirstName         = "";
    params.CPLastName          = "";
    params.CPGender            = 0;
    params.Telephone           = "";
    params.Fax                 = "";
    params.EmailGeneral        = "";
    params.EmailReservations   = "";
    params.Web                 = "";
    params.AccommodationTypeID = 0;
    params.CurrencyID          = 0;
    params.NrOfRooms           = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.OtaEditHotelDocDescriptionParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.DocID       = 0;
    params.LangID      = 0;
    params.DocTypeID   = 0;
    params.Description = "";

    return params;
};

window.RQParam.OtaEditHotelEngineServiceTemplateParams
    = function() {
    var params = { };

    params.HotelID                       = 0;
    params.WithFontFamily                = 0;
    params.WithDefaultButtonOverride     = 0;
    params.WithInfoButtonOverride        = 0;
    params.WithSuccessButtonOverride     = 0;
    params.WithWarningButtonOverride     = 0;
    params.WithDangerButtonOverride      = 0;
    params.WithOutlineInfoButtonOverride = 0;
    params.FontFamily                    = "";
    params.Background                    = "";
    params.MainText                      = "";
    params.MutedText                     = "";
    params.DescriptionText               = "";
    params.MenuItemTickUnckecked         = "";
    params.ActionOK                      = "";
    params.ActionWithNote                = "";
    params.DeleteAndWarning              = "";
    params.SignInDividerBackground       = "";
    params.SignInDividerText             = "";
    params.SearchAndCartBackground       = "";
    params.SearchAndCartDivider          = "";
    params.SearchAndCartTitle            = "";
    params.DropdownBackground            = "";
    params.CartSummaryBackground         = "";
    params.CartSummaryBorder             = "";
    params.OfferSelectedBackground       = "";
    params.OfferSelectedBorder           = "";
    params.UtilityLinkText               = "";
    params.ButtonDisabledBackground      = "";
    params.ButtonDisabledBorder          = "";
    params.ButtonDisabledText            = "";
    params.DefaultButtonText             = "";
    params.DefaultButtonBackground       = "";
    params.DefaultButtonBackgroundHover  = "";
    params.DefaultButtonBorderHover      = "";
    params.DefaultButtonShadowRed        = 0;
    params.DefaultButtonShadowGreen      = 0;
    params.DefaultButtonShadowBlue       = 0;
    params.DefaultButtonBorderActive     = "";
    params.InfoButtonText                = "";
    params.InfoButtonBackground          = "";
    params.InfoButtonBackgroundHover     = "";
    params.InfoButtonBorderHover         = "";
    params.InfoButtonShadowRed           = 0;
    params.InfoButtonShadowGreen         = 0;
    params.InfoButtonShadowBlue          = 0;
    params.InfoButtonBorderActive        = "";
    params.SuccessButtonText             = "";
    params.SuccessButtonBackground       = "";
    params.SuccessButtonBackgroundHover  = "";
    params.SuccessButtonBorderHover      = "";
    params.SuccessButtonShadowRed        = 0;
    params.SuccessButtonShadowGreen      = 0;
    params.SuccessButtonShadowBlue       = 0;
    params.SuccessButtonBorderActive     = "";
    params.WarningButtonText             = "";
    params.WarningButtonBackground       = "";
    params.WarningButtonBackgroundHover  = "";
    params.WarningButtonBorderHover      = "";
    params.WarningButtonShadowRed        = 0;
    params.WarningButtonShadowGreen      = 0;
    params.WarningButtonShadowBlue       = 0;
    params.WarningButtonBorderActive     = "";
    params.DangerButtonText              = "";
    params.DangerButtonBackground        = "";
    params.DangerButtonBackgroundHover   = "";
    params.DangerButtonBorderHover       = "";
    params.DangerButtonShadowRed         = 0;
    params.DangerButtonShadowGreen       = 0;
    params.DangerButtonShadowBlue        = 0;
    params.DangerButtonBorderActive      = "";
    params.InfoOutlineButtonContent      = "";
    params.InfoOutlineButtonBackground   = "";
    params.InfoOutlineButtonShadowRed    = 0;
    params.InfoOutlineButtonShadowGreen  = 0;
    params.InfoOutlineButtonShadowBlue   = 0;

    return params;
};

window.RQParam.OtaEditHotelMapDescriptionParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.HotelMapID  = 0;
    params.Description = "";

    return params;
};

window.RQParam.OtaEditHotelPhotoDescriptionParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.HotelPhotoID = 0;
    params.Description  = "";
    params.LangID       = 0;

    return params;
};

window.RQParam.OtaEditHotelRouteDescriptionParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RouteDescription = "";
    params.LangID           = 0;

    return params;
};

window.RQParam.OtaExtractSearchLocationXMLParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaFeedbackInsertParams
    = function() {
    var params = { };

    params.CustomerID       = 0;
    params.ReviewedHotelID  = 0;
    params.ReservationID    = 0;
    params.LangID           = 0;
    params.Cleanliness      = 0;
    params.Facilities       = 0;
    params.DisabledFriendly = 0;
    params.Service          = 0;
    params.Location         = 0;
    params.Pricing          = 0;
    params.GeneralComments  = "";
    params.ClientIP         = "";
    params.TravelPurposeID  = 0;
    params.ClientStatusID   = 0;
    params.Status           = 0;
    params.Name             = "";
    params.Email            = "";

    return params;
};

window.RQParam.OtaFinalizeGooglePromoSyncParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaFinalizeGooglePropertySyncParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetAccommodationStatusesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaGetAccommodationTypesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaGetActiveConcentricRunParams
    = function() {
    var params = { };

    params.ConcentricRunID = 0;

    return params;
};

window.RQParam.OtaGetActiveConcentricSearchParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetActiveCountriesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaGetAllHotelPhotosAndDescriptionsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetBNPartnerParams
    = function() {
    var params = { };

    params.BNPartnerID = 0;

    return params;
};

window.RQParam.OtaGetCCTypeNameByIDParams
    = function() {
    var params = { };

    params.CCTypeID = 0;

    return params;
};

window.RQParam.OtaGetChainReservationListParams
    = function() {
    var params = { };

    params.HotelChainID = 0;
    params.StartDate    = "Date";
    params.EndDate      = "Date";
    params.SearchTypeID = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.OtaGetCountryLocationsAllParams
    = function() {
    var params = { };

    params.CountryID = 0;
    params.LangID    = 0;
    params.OrderBy   = 0;

    return params;
};

window.RQParam.OtaGetCountryNameByIDParams
    = function() {
    var params = { };

    params.CountryID = 0;
    params.LangID    = 0;

    return params;
};

window.RQParam.OtaGetCurrenciesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaGetCurrencyByIDParams
    = function() {
    var params = { };

    params.CurrencyID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.OtaGetCustomerPasswordByGuestParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.GuestID = 0;

    return params;
};

window.RQParam.OtaGetCustomerReviewsParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.OtaGetDocTypesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaGetGoogleHotelsParams
    = function() {
    var params = { };

    params.LangID        = 0;
    params.PublishedOnly = 0;

    return params;
};

window.RQParam.OtaGetGooglePropertyIDParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetGuestCategoriesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaGetHotelByIDParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelChainHotelListParams
    = function() {
    var params = { };

    params.HotelChainID = 0;

    return params;
};

window.RQParam.OtaGetHotelChainInfoParams
    = function() {
    var params = { };

    params.HotelChainID = 0;

    return params;
};

window.RQParam.OtaGetHotelChainXMLProvidersParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetHotelCPolicyParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.OtaGetHotelCPolicyFreeUntilParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelDescriptionsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelDetailsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelDiscountSettingsStatusParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelDistanceFromCenterParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelDocsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelEngineServiceTemplateSettingsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelFacilitiesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.OtaGetHotelFacilitiesAllParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.OtaGetHotelFeedbackParams
    = function() {
    var params = { };

    params.HotelID         = 0;
    params.GuestCategoryID = 0;
    params.TravelPurposeID = 0;
    params.OrderBy         = 0;
    params.LangID          = 0;

    return params;
};

window.RQParam.OtaGetHotelInfoParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.OtaGetHotelMemberDiscountPeriodsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelPasswordParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelPhotosParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelPoliciesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.OtaGetHotelRatingParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelReservationsEmailParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelsNeedingDiscountSettingsNotifParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetHotelsNeedingGooglePromoSyncParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetHotelsNeedingGooglePropertySyncParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetHotelsNeedingSpotlightSettingsNotifParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetHotelSpotlightDiscountsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelSpotlightPriceStatusParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetHotelsWithGoogleSyncFailureParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetHotelXMLProviderParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetLocationGeoCodeParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetLocationGeoCodeDetailsParams
    = function() {
    var params = { };

    params.LocationGeoCodeID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.OtaGetLocationGeoCodeIDFromGPlaceIDParams
    = function() {
    var params = { };

    params.GPlaceID = "";

    return params;
};

window.RQParam.OtaGetLocationsByNameFragmentParams
    = function() {
    var params = { };

    params.Fragment = "";
    params.LangID   = 0;

    return params;
};

window.RQParam.OtaGetLocationsHotelsParams
    = function() {
    var params = { };

    params.CountryID         = 0;
    params.LocationGeoCodeID = 0;
    params.LangID            = 0;
    params.OrderBy           = 0;

    return params;
};

window.RQParam.OtaGetLocationVATParams
    = function() {
    var params = { };

    params.LocationGeoCodeID = 0;
    params.ArrDay            = "Date";

    return params;
};

window.RQParam.OtaGetMatchingHotelsParams
    = function() {
    var params = { };

    params.HotelID   = 0;
    params.HotelName = "";
    params.email     = "";

    return params;
};

window.RQParam.OtaGetMLSearchLocationsParams
    = function() {
    var params = { };

    params.LangID           = 0;
    params.SearchLocationID = 0;

    return params;
};

window.RQParam.OtaGetNearbyPlaceDetailsParams
    = function() {
    var params = { };

    params.GPlaceID = "";

    return params;
};

window.RQParam.OtaGetNearbyPlacesNeedingEmailParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetNewUnpublishedHotelsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetOfferTypeDetailsParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.OfferTypeID = 0;
    params.MaxPersons  = 0;
    params.LangID      = 0;

    return params;
};

window.RQParam.OtaGetOutstandingGoogleScheduleItemsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetPasswordCustomerParams
    = function() {
    var params = { };

    params.Email = "";

    return params;
};

window.RQParam.OtaGetPasswordHotelParams
    = function() {
    var params = { };

    params.Email = "";

    return params;
};

window.RQParam.OtaGetPhotosByHotelIDParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetRegisteredPropertyParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetRoomTypeDeletionWarningInHotelNativeLangParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetRoomTypeNamesParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.LangID  = 0;

    return params;
};

window.RQParam.OtaGetRoomTypeNamesAllParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;

    return params;
};

window.RQParam.OtaGetRoomTypePhotoDescriptionsAllParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.RoomTypeID   = 0;
    params.HotelPhotoID = 0;

    return params;
};

window.RQParam.OtaGetRoomTypePhotosParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.RoomTypeID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.OtaGetRoomTypesCMParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetSearchLocationsByNameFragmentParams
    = function() {
    var params = { };

    params.Fragment = "";
    params.LangID   = 0;

    return params;
};

window.RQParam.OtaGetStripePaymentStatusParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.StripeID = "";

    return params;
};

window.RQParam.OtaGetSubPayPeriodsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaGetTopGPlaceNeedingTranslationParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetTopLocationGeoCodeForSearchLocIDParams
    = function() {
    var params = { };

    params.searchloc_id = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.OtaGetTopSearchLocIDForLocationGeoCodeParams
    = function() {
    var params = { };

    params.LocationGeoCodeID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.OtaGetTravelPurposesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaGetUnverifiedLocationGeoCodeHotelsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGetUnverifiedLocationGeoCodesParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaGrantOrGetPMSAPIKeyParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaHotelBelongsToChainParams
    = function() {
    var params = { };

    params.HotelChainID = 0;
    params.HotelID      = 0;

    return params;
};

window.RQParam.OtaHotelHasEngineTemplateParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaHotelHasXMLProviderParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaHotelNeedsDiscountSettingsActionParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaIncrementBNPartnerRequestIDParams
    = function() {
    var params = { };

    params.BNPartnerID = 0;

    return params;
};

window.RQParam.OtaInitGooglePromoSyncParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaInitGoogleProperySyncParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaLogCMRequestParams
    = function() {
    var params = { };

    params.IPAddress    = "";
    params.HotelChainID = 0;
    params.HotelID      = "";
    params.LoginName    = "";
    params.RequestType  = 0;
    params.RequestXML   = "";

    return params;
};

window.RQParam.OtaMakeOTAPublishRequestParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaMarkConcentricRunQueryAsDoneParams
    = function() {
    var params = { };

    params.ConcentricRunID = 0;
    params.QueryID         = 0;
    params.SeachHadError   = 0;
    params.DetailsHadError = 0;
    params.IsDone          = 0;

    return params;
};

window.RQParam.OtaMarkHotelAsRetrievedByGoogleParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaMarkReservationFromGoogleParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.OtamlGetAllLocationGeoCodeNamesParams
    = function() {
    var params = { };

    params.LocationGeoCodeID = 0;

    return params;
};

window.RQParam.OtamlGetAllSearchLocationNamesParams
    = function() {
    var params = { };

    params.SearchLocationID = 0;
    params.LangID           = 0;

    return params;
};

window.RQParam.OtamlGetGuestCategoryParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtamlGetTravelPurposesParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.OtaNewRegisterHotelParams
    = function() {
    var params = { };

    params.AccommodationName  = "";
    params.Address            = "";
    params.City               = "";
    params.ZIP                = "";
    params.CountryID          = 0;
    params.Lat                = 0;
    params.Lng                = 0;
    params.place_id           = "";
    params.property_gplace_id = "";
    params.CP_FirstName       = "";
    params.CP_LastName        = "";
    params.CP_Gender          = 0;
    params.Telephone          = "";
    params.Email_General      = "";
    params.URL                = "";
    params.Login              = "";
    params.Password           = "";

    return params;
};

window.RQParam.OtaNewRegisterHotelCheckParams
    = function() {
    var params = { };

    params.HotelRegisterID   = 0;
    params.AccommodationName = "";

    return params;
};

window.RQParam.OtaNewStripePaymentParams
    = function() {
    var params = { };

    params.HotelID            = 0;
    params.StripeID           = "";
    params.Amount             = 0;
    params.BalanceTransaction = "";
    params.Source             = "";
    params.Status             = "";
    params.Email              = "";
    params.ReceiptURL         = "";
    params.ZIP                = "";
    params.Description        = "";
    params.FailureCode        = "";
    params.FailureMessage     = "";
    params.Created            = "Date";

    return params;
};

window.RQParam.OtaNotifyDiscountSettingsChangeParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaNotifyNewHotelChainAssignmentsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaNotifyOutstandingPMSActivationsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaNotifySpotlightSettingsChangeParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaNudgeHotelDocSortOrderParams
    = function() {
    var params = { };

    params.HotelID = 0;
    params.DocID   = 0;
    params.Up      = 0;

    return params;
};

window.RQParam.OtaNudgeHotelMapsSortOrderParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.HotelMapID = 0;
    params.Up         = 0;

    return params;
};

window.RQParam.OtaNudgeHotelPhotoSortOrderParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.HotelPhotoID = 0;
    params.Up           = 0;

    return params;
};

window.RQParam.OtaPopulateGooglePriceSchdeuleParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaPopulateUnverifiedLocationGeoCodeNamesParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.OtaPropagateCancellationToStardeckParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.OtaPropagateReservationToStardeckParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.ReservationID = 0;

    return params;
};

window.RQParam.OtaPropagateRoomCancellationToStardeckParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.RoomReservationID = 0;

    return params;
};

window.RQParam.OtaPublishHotelParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaQuestionaireInsParams
    = function() {
    var params = { };

    params.AccommodationName   = "";
    params.AccommodationTypeID = 0;
    params.ClassificationID    = 0;
    params.CountryID           = 0;
    params.FirstName           = "";
    params.LastName            = "";
    params.Function            = "";
    params.Subscription        = 0;
    params.Commission          = 0;
    params.Price               = 0;
    params.Percentage          = 0;
    params.SmartContracts      = 0;
    params.TravelCryptoCoin    = 0;
    params.GeneralEmail        = "";
    params.Comments            = "";

    return params;
};

window.RQParam.OtaRecordGooglePriceCheckAttemptParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.ActionID = 0;

    return params;
};

window.RQParam.OtaRecordGooglePriceCheckResultParams
    = function() {
    var params = { };

    params.HotelID        = 0;
    params.ActionID       = 0;
    params.ActionStatusID = 0;
    params.Result         = 0;

    return params;
};

window.RQParam.OtaRegisterHotelDocFileNameParams
    = function() {
    var params = { };

    params.HotelID  = 0;
    params.DocID    = 0;
    params.FileName = "";

    return params;
};

window.RQParam.OtaRegisterHotelMapFileNameParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.HotelMapID = 0;
    params.FileName   = "";

    return params;
};

window.RQParam.OtaRegisterHotelPhotoFileNameParams
    = function() {
    var params = { };

    params.HotelID      = 0;
    params.HotelPhotoID = 0;
    params.FileName     = "";

    return params;
};

window.RQParam.OtaRegisterWebExceptionParams
    = function() {
    var params = { };

    params.RequestID     = "";
    params.URI           = "";
    params.IPAddress     = "";
    params.UserAgent     = "";
    params.Referer       = "";
    params.ExceptionText = "";
    params.StackTrace    = "";
    params.Priority      = 0;

    return params;
};

window.RQParam.OtaRegisterWebExceptionExtendedParams
    = function() {
    var params = { };

    params.IsWarning      = 0;
    params.RequestID      = "";
    params.RequestTime    = "";
    params.URI            = "";
    params.IPAddress      = "";
    params.UserAgent      = "";
    params.Referer        = "";
    params.Message        = "";
    params.ExceptionText  = "";
    params.StackTrace     = "";
    params.ExtraDebugInfo = "";
    params.Priority       = 0;

    return params;
};

window.RQParam.OtaResetHotelOTAConfirmationsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaSaveHotelDescriptionViaGoogleParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.Description = "";
    params.LangID      = 0;

    return params;
};

window.RQParam.OtaSelectMapsParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaSetHotelDiscountSettingsStatusParams
    = function() {
    var params = { };

    params.HotelID               = 0;
    params.AllowAutoNonRef       = 0;
    params.AllowAutoMemberOnly   = 0;
    params.AllowAutoLastMintue   = 0;
    params.AllowAutoEarlyBird    = 0;
    params.AllowAutoWalkIn       = 0;
    params.NonRefDiscount        = 0;
    params.NonRefByCM            = 0;
    params.MemberOnlyDiscount    = 0;
    params.LastMinuteDiscount    = 0;
    params.LastMinuteAvThreshold = 0;
    params.EarlyBirdDiscount     = 0;
    params.EarlyBirdAdvanceDays  = 0;
    params.WalkInDiscount        = 0;
    params.WalkInIsNonRef        = 0;
    params.LangID                = 0;

    return params;
};

window.RQParam.OtaSetHotelSpotlightPriceStatusParams
    = function() {
    var params = { };

    params.HotelID             = 0;
    params.AllowSpotlightPrice = 0;
    params.LangID              = 0;

    return params;
};

window.RQParam.OtaStoreNearbyPlacePhotoParams
    = function() {
    var params = { };

    params.gplace_id       = "";
    params.photo_reference = "";
    params.Width           = 0;
    params.Height          = 0;

    return params;
};

window.RQParam.OtaStoreNearbyPlaceResultParams
    = function() {
    var params = { };

    params.gplace_id                = "";
    params.ConcentricRunID          = 0;
    params.QueryID                  = 0;
    params.FromKeyword              = "";
    params.FromSearchLat            = 0;
    params.FromSearchLng            = 0;
    params.Lat                      = 0;
    params.Lng                      = 0;
    params.Name                     = "";
    params.Rating                   = 0;
    params.UserRatingsTotal         = 0;
    params.Vicinity                 = "";
    params.BusinessStatus           = "";
    params.Country                  = "";
    params.CountryShort             = "";
    params.Region                   = "";
    params.Locality                 = "";
    params.PostCode                 = "";
    params.FormattedAddress         = "";
    params.FormattedPhoneNumber     = "";
    params.InternationalPhoneNumber = "";
    params.WebSite                  = "";

    return params;
};

window.RQParam.OtaUnpublishHotelParams
    = function() {
    var params = { };

    params.HotelID = 0;

    return params;
};

window.RQParam.OtaUpdateFacilityParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.FacilityID = 0;
    params.IsChecked  = 0;

    return params;
};

window.RQParam.OtaUpdateGPlaceMLNameCollectionParams
    = function() {
    var params = { };

    params.gplace_id                   = "";
    params.LangID                      = 0;
    params.locality                    = "";
    params.sublocality                 = "";
    params.colloquial_area             = "";
    params.neighborhood                = "";
    params.premise                     = "";
    params.postal_code                 = "";
    params.natural_feature             = "";
    params.airport                     = "";
    params.park                        = "";
    params.point_of_interest           = "";
    params.tourist_attraction          = "";
    params.administrative_area_level_1 = "";
    params.administrative_area_level_2 = "";
    params.administrative_area_level_3 = "";
    params.administrative_area_level_4 = "";
    params.administrative_area_level_5 = "";

    return params;
};

window.RQParam.OtaUpdateNearbyPlacesEmailParams
    = function() {
    var params = { };

    params.gplace_id = "";
    params.Email     = "";
    params.HadError  = 0;

    return params;
};

window.RQParam.OtaUpdateStripePaymentStatusParams
    = function() {
    var params = { };

    params.StripeID = "";
    params.Status   = "";

    return params;
};

window.RQParam.OtaUpdateViaCMParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.RoomTypeID       = 0;
    params.StartDate        = "Date";
    params.EndDate          = "Date";
    params.WithAvailability = 0;
    params.Availability     = 0;
    params.WithPrice        = 0;
    params.Price            = 0;
    params.WithMLOS         = 0;
    params.MLOS             = 0;

    return params;
};

window.RQParam.OtaVerifyGoogleTranslateLimitParams
    = function() {
    var params = { };

    params.OpDay = "Date";

    return params;
};

window.RQParam.OtaVerifyLocationGeoCodeParams
    = function() {
    var params = { };

    params.LocationGeoCodeID = 0;

    return params;
};

window.RQParam.OtaVerifyNearbyPlaceActivationStatusParams
    = function() {
    var params = { };

    params.GPlaceID = "";
    params.Email    = "";

    return params;
};

window.RQParam.GlocalAddGlocalGeoLocationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.CustomerID    = 0;
    params.GeoLocationID = 0;

    return params;
};

window.RQParam.GlocalAddUserLanguageParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.GlocalAddUserPhotoParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.CustomerID    = 0;
    params.FileName      = "";
    params.DescriptionEN = "";

    return params;
};

window.RQParam.GlocalAddUserProfilePictureParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.CustomerID       = 0;
    params.ProfilePictueURL = "";

    return params;
};

window.RQParam.GlocalAlertGlocalSignUpParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};

window.RQParam.GlocalDeleteUserPictureParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.PictureID  = 0;

    return params;
};

window.RQParam.GlocalEditGlocalDetailsParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.CustomerID       = 0;
    params.GeoLocationID    = 0;
    params.DisplayName      = "";
    params.IdentityVerified = 0;

    return params;
};

window.RQParam.GlocalEditUserPictureDescriptionParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.CustomerID  = 0;
    params.PictureID   = 0;
    params.Description = "";

    return params;
};

window.RQParam.GlocalGetEventsByLocationGeoCodeIDParams
    = function() {
    var params = { };

    params.LocationGeoCodeID         = 0;
    params.RestrictByGuideCategoryID = 0;
    params.GuideCategoryID           = 0;
    params.RestrictByInfoTypeID      = 0;
    params.InfoTypeID                = 0;
    params.RestrictByDate            = 0;
    params.LangID                    = 0;

    return params;
};

window.RQParam.GlocalGetGlocalDetailsParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};

window.RQParam.GlocalGetGlocalGeoLocationsParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.GlocalGetGlocalLanguagesByLocationGeoCodeIDParams
    = function() {
    var params = { };

    params.LocationGeoCodeID = 0;

    return params;
};

window.RQParam.GlocalGetGlocalLanguagesBySearchLocationParams
    = function() {
    var params = { };

    params.searchloc_id = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.GlocalGetGlocalsByLocationGeoCodeIDParams
    = function() {
    var params = { };

    params.LocationGeoCodeID = 0;
    params.LangID            = 0;

    return params;
};

window.RQParam.GlocalGetGlocalsBySearchLocationParams
    = function() {
    var params = { };

    params.searchloc_id = 0;
    params.LangID       = 0;

    return params;
};

window.RQParam.GlocalGetMessagesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};

window.RQParam.GlocalGetNumUnreadMessagesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};

window.RQParam.GlocalGetSpokenLanguagesParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.GlocalGetUnalertedGlocalSignUpsParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.GlocalGetUnalertedUserMessagesParams
    = function() {
    var params = { };


    return params;
};

window.RQParam.GlocalGetUserInterestsParams
    = function() {
    var params = { };

    params.LangID = 0;

    return params;
};

window.RQParam.GlocalGetUserInterestsByUserParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.GlocalGetUserLanguagesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};

window.RQParam.GlocalGetUserPicturesParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};

window.RQParam.GlocalIndicateProfilePictureParams
    = function() {
    var params = { };

    params.HotelID           = 0;
    params.CustomerID        = 0;
    params.PictureID         = 0;
    params.ProfilePictureURL = "";

    return params;
};

window.RQParam.GlocalIndicateUserInterestParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.InterestID = 0;
    params.IsInterest = 0;

    return params;
};

window.RQParam.GlocalMarkMessagesAsReadParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};

window.RQParam.GlocalMarkMessagesAsReadByUserParams
    = function() {
    var params = { };

    params.FromHotelID    = 0;
    params.FromCustomerID = 0;
    params.ToHotelID      = 0;
    params.ToCustomerID   = 0;

    return params;
};

window.RQParam.GlocalMessageGlocalParams
    = function() {
    var params = { };

    params.HotelID          = 0;
    params.CustomerID       = 0;
    params.GlocalHotelID    = 0;
    params.GlocalCustomerID = 0;
    params.Message          = "";

    return params;
};

window.RQParam.GlocalRegisterGlocalParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.CustomerID    = 0;
    params.DisplayName   = "";
    params.GeoLocationID = 0;

    return params;
};

window.RQParam.GlocalRegisterUserPhotoFileNameParams
    = function() {
    var params = { };

    params.HotelID     = 0;
    params.CustomerID  = 0;
    params.UserPhotoID = 0;
    params.FileName    = "";

    return params;
};

window.RQParam.GlocalRemoveGlocalGeoLocationParams
    = function() {
    var params = { };

    params.HotelID       = 0;
    params.CustomerID    = 0;
    params.GeoLocationID = 0;
    params.LangID        = 0;

    return params;
};

window.RQParam.GlocalRemoveUserLanguageParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;
    params.LangID     = 0;

    return params;
};

window.RQParam.GlocalUnregisterGlocalParams
    = function() {
    var params = { };

    params.HotelID    = 0;
    params.CustomerID = 0;

    return params;
};



//////////////////
// WEBPACK FOOTER
// ./src/RQuery/RQueryRESTParams.js
// module id = 402
// module chunks = 0